
(function () {
	'use strict';
	
	var module = angular.module('imApp');
	
	
	module.component('mapView3d', {
		templateUrl: 'views/components/views/mapView3d/mapView3d.template.html?v=' + module.version,
		controllerAs: 'vm',
		controller: ['$stateParams', 'stateService', 'utilityService', 'mapView3dService', function ($stateParams, stateService, utilityService, mapView3dService) {
	
			// #region VARIABLES & DEFINITIONS
			
			var vm = this;
			var argType = $stateParams.argtype;
			var argValue = $stateParams.argvalue;
			
			vm.model = {
				setting: {},
				isCesiumLoaded: false
			};
			
			// #endregion VARIABLES & DEFINITIONS

			// #region LOAD PROCEDURE FUNCTION CALLS
			mapView3dService.getMapView3d({ 
				argtype: argType,
				argvalue: argValue
			}).then(function (result) {
				angular.copy(result[0], vm.model.setting);
			});
			// #endregion LOAD PROCEDURE FUNCTION CALLS

            
            

            // #region darg-slider
            function toTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum/1000
            }

            function zeroPad(num, places) {
                var zero = places - num.toString().length + 1;
                return Array(+(zero > 0 && zero)).join("0") + num;
            }

            function formatDT(__dt) {
                dateUTC = __dt.toUTCString();
                return dateUTC
                /*
                var year = __dt.getFullYear();
                var month = zeroPad(__dt.getMonth()+1, 2);
                var date = zeroPad(__dt.getDate(), 2);
                var hours = zeroPad(__dt.getHours(), 2);
                var minutes = zeroPad(__dt.getMinutes(), 2);
                var seconds = zeroPad(__dt.getSeconds(), 2);
                return year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;*/

            }


            (function( $, undefined ) {
                $.widget("ui.dragslider", $.ui.slider, {
        
                    options: $.extend({},$.ui.slider.prototype.options,{rangeDrag:false}),
        
                    _create: function() {
                        $.ui.slider.prototype._create.apply(this,arguments);
                        this._rangeCapture = false;
                    },
        
                    _mouseCapture: function( event ) { 
                        var o = this.options;

                        if ( o.disabled ) return false;
            
                        if(event.target == this.range.get(0) && o.rangeDrag == true && o.range == true) {
                            this._rangeCapture = true;
                            this._rangeStart = null;
                        }
                        else {
                            this._rangeCapture = false;
                        }
            
                        $.ui.slider.prototype._mouseCapture.apply(this,arguments);

                        if(this._rangeCapture == true) {	
                            this.handles.removeClass("ui-state-active").blur();	
                        }
            
                        return true;
                    },
        
                    _mouseStop: function( event ) {
                        this._rangeStart = null;
                        return $.ui.slider.prototype._mouseStop.apply(this,arguments);
                    },
        
                    _slide: function( event, index, newVal ) {
            
        
                        if(!this._rangeCapture) { 
                            return $.ui.slider.prototype._slide.apply(this,arguments);
                        }
            
                        if(this._rangeStart == null) {
                            this._rangeStart = newVal;
                        }
            
                        var oldValLeft = this.options.values[0],
                            oldValRight = this.options.values[1],
                            slideDist = newVal - this._rangeStart,
                            newValueLeft = oldValLeft + slideDist,
                            newValueRight = oldValRight + slideDist,
                            allowed;
            
                        if ( this.options.values && this.options.values.length ) {
                            if(newValueRight > this._valueMax() && slideDist > 0) {
                                slideDist -= (newValueRight-this._valueMax());
                                newValueLeft = oldValLeft + slideDist;
                                newValueRight = oldValRight + slideDist;
                            }
                
                            if(newValueLeft < this._valueMin()) {
                                slideDist += (this._valueMin()-newValueLeft);
                                newValueLeft = oldValLeft + slideDist;
                                newValueRight = oldValRight + slideDist;
                            }

                            if ( slideDist != 0 ) {
                                var newValues = this.values();
                                newValues[ 0 ] = newValueLeft;
                                newValues[ 1 ] = newValueRight;
                    
                                // A slide can be canceled by returning false from the slide callback
                                allowed = this._trigger( "slide", event, {
                                    handle: this.handles[ index ],
                                    value: slideDist,
                                    values: newValues
                            } );
                
                            if ( allowed !== false ) {
                                this.values( 0, newValueLeft, true );
                                this.values( 1, newValueRight, true );
                            }
                            this._rangeStart = newVal;
                            }
                        }  
        
                    },
     

                });

            })(jQuery);
            // #endregion darg-slider


            // #region touchscreen
            !function(a){function f(a,b){if(!(a.originalEvent.touches.length>1)){a.preventDefault();var c=a.originalEvent.changedTouches[0],d=document.createEvent("MouseEvents");d.initMouseEvent(b,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),a.target.dispatchEvent(d)}}if(a.support.touch="ontouchend"in document,a.support.touch){var e,b=a.ui.mouse.prototype,c=b._mouseInit,d=b._mouseDestroy;b._touchStart=function(a){var b=this;!e&&b._mouseCapture(a.originalEvent.changedTouches[0])&&(e=!0,b._touchMoved=!1,f(a,"mouseover"),f(a,"mousemove"),f(a,"mousedown"))},b._touchMove=function(a){e&&(this._touchMoved=!0,f(a,"mousemove"))},b._touchEnd=function(a){e&&(f(a,"mouseup"),f(a,"mouseout"),this._touchMoved||f(a,"click"),e=!1)},b._mouseInit=function(){var b=this;b.element.bind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),c.call(b)},b._mouseDestroy=function(){var b=this;b.element.unbind({touchstart:a.proxy(b,"_touchStart"),touchmove:a.proxy(b,"_touchMove"),touchend:a.proxy(b,"_touchEnd")}),d.call(b)}}}(jQuery);
            // #endregion  touchscreen


            //var gpx_file_names = ["views/components/views/mapView3d/Kjenndalen_10-11062022_v_1.4.gpx"];


			// ----------------------------- load_initial_parameters ------------------------------- //
            function load_initial_parameters() {
			  return new Promise(function(resolve, reject) {
				if (typeof Cesium === 'undefined') {
				  var script = document.createElement('script');
				  script.src = 'https://cesium.com/downloads/cesiumjs/releases/1.107/Build/Cesium/Cesium.js';
				  document.head.appendChild(script);

				  var linkCesium = document.createElement('link');
				  linkCesium.rel = 'stylesheet';
				  linkCesium.href = 'https://cesium.com/downloads/cesiumjs/releases/1.104/Build/Cesium/Widgets/widgets.css';
				  document.head.appendChild(linkCesium);

				  var linkMapView3d = document.createElement('link');
				  linkMapView3d.rel = 'stylesheet';
				  linkMapView3d.href = 'views/components/views/mapView3d/mapView3d.css';
				  document.head.appendChild(linkMapView3d);

                  vm.model.isCesiumLoaded = true;
				}

				// Resolve the promise when Cesium is loaded
				var intervalId = setInterval(function() {
                    if (typeof Cesium !== 'undefined' && typeof vm.model.setting.gpx_content !== 'undefined') {
					    clearInterval(intervalId);
					    resolve();
				  }
				}, 10);
			  });
			}
			
			
			// ------------------------ add_geonorge_imagery_providers ------------------------ //
            async function add_geonorge_imagery_providers(viewer){

                // Add Norgeskart
                function create_norgeskart_imagery_provider(layer){

                    var tileMatrixLabels = ['EPSG:3857:0',  'EPSG:3857:1',  'EPSG:3857:2',  'EPSG:3857:3', 
                                            'EPSG:3857:4',  'EPSG:3857:5',  'EPSG:3857:6',  'EPSG:3857:7', 
                                            'EPSG:3857:8',  'EPSG:3857:9',  'EPSG:3857:10', 'EPSG:3857:11', 
                                            'EPSG:3857:12', 'EPSG:3857:13', 'EPSG:3857:14', 'EPSG:3857:15', 
                                            'EPSG:3857:16', 'EPSG:3857:17', 'EPSG:3857:18', 'EPSG:3857:19', 
                                            'EPSG:3857:20'];


                    var imageryProvider = new Cesium.WebMapTileServiceImageryProvider({
                            url: 'https://opencache.statkart.no/gatekeeper/gk/gk.open_wmts',
                            layer: layer,
                            style: 'default',
                            format: 'image/png',
                            tileMatrixSetID: 'EPSG:3857',
                            tileMatrixLabels: tileMatrixLabels,
                            maximumLevel: tileMatrixLabels.length - 1
                            
                        });
                        return imageryProvider; // Replace with your custom imagery provider implementation
                }


                // Topp 4
                var topo4ProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Norgeskart Topo 4', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1522072132.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function(){
                        return create_norgeskart_imagery_provider('topo4');
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(topo4ProviderViewModel);


                // Toporaster4
                var toporasterProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Norgeskart Toporaster 4', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1522084989.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        return create_norgeskart_imagery_provider('toporaster4');
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(toporasterProviderViewModel);



                // Norgeskart Bakgrunn 2
                var norgeskartBakgrunnProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Norgeskart Bakgrunn 2', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1522092412.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        return create_norgeskart_imagery_provider('norgeskart_bakgrunn2');
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(norgeskartBakgrunnProviderViewModel);



                // Topografisk norgeskart 4 graatone
                var topo4GraatoneProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Norgeskart Topo 4 gråtone', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1522094718.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        return create_norgeskart_imagery_provider('topo4graatone');
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(topo4GraatoneProviderViewModel);



                // Terreng Norgeskart
                var terrengNorgeskartProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Norgeskart Terreng', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1522132489.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        return create_norgeskart_imagery_provider('terreng_norgeskart');
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(terrengNorgeskartProviderViewModel);



                // Sjøkartraster
                var sjokartrasterProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Norgeskart Sjøkartraster', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1522112997.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        return create_norgeskart_imagery_provider('sjokartraster');
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(sjokartrasterProviderViewModel);



                // DTM Skyggerelieff
                var dtmSkyggerelieffProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Høydedata DTM Skyggerelieff ', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1615014890.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        var dtmSkyggereliefImageryProvider = new Cesium.WebMapServiceImageryProvider({
                            url: 'https://hoydedata.no/arcgis/services/DTM/ImageServer/WMSServer',
                            layers: 'skyggerelieff',
                            parameters: {
                                //styles: 'default',
                                //service: 'WMS',
                                //version: '1.3.0',
                                request: 'GetMap',
                                format: 'image/png',
                                crs: 'EPSG:3857',
                                //transparent: false
                            }      
                        });
                        return dtmSkyggereliefImageryProvider
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(dtmSkyggerelieffProviderViewModel);


               // DTM Multiskyggerelieff
               var dtmMultiskyggerelieffProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'Høydedata DTM Multiskyggerelieff', // The name displayed in the baseLayerPicker
                    tooltip: 'TBC', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1700113520.png?w=200', // URL to an icon image
                    category: 'Geonorge',
                    creationFunction: function() {
                        var dtmMultiskyggerelieffImageryProvider = new Cesium.WebMapServiceImageryProvider({
                            url: 'https://hoydedata.no/arcgis/services/DTM/ImageServer/WMSServer',
                            layers: 'multiskyggerelieff',
                            parameters: {
                                //styles: 'default',
                                //service: 'WMS',
                                //version: '1.3.0',
                                request: 'GetMap',
                                format: 'image/png',
                                crs: 'EPSG:3857',
                                //srs: 'EPSG:3857',
                                //transparency: false
                            }      
                        });
                        return dtmMultiskyggerelieffImageryProvider
                    }
                });
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(dtmMultiskyggerelieffProviderViewModel);



        
        }


            // ------------------------ initialize_cesium_viewer --------------------------- //
            async function initialize_cesium_viewer() {

                // Your access token can be found at: https://ion.cesium.com/tokens.   
                Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI0YzQ5Yzc5OS1kOGZmLTQxYzgtOGJkYS0yNzM1YzY3YmVmYzciLCJpZCI6MTQxMzgyLCJpYXQiOjE2ODQ5OTkxMzB9.P_s4spv7Wg6Dt1DlRwWCInFwU1kUZ_ALikeVbSht7_I';


                // Default Imagery: ArcGIS World Imagery Provider
                var ESRIImageryProviderViewModel = await new Cesium.ProviderViewModel({
                    name: 'ArcGIS World Imagery',
                    tooltip: 'ESRI World Imagery from ArcGIS',
                    iconUrl: Cesium.buildModuleUrl('Widgets/Images/ImageryProviders/ArcGisMapServiceWorldImagery.png'),
                    category: 'ArcGIS',
                    creationFunction: function () {
                        var ESRIImageryProvider = Cesium.ArcGisMapServerImageryProvider.fromUrl(
                            "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer")
                        return ESRIImageryProvider
                    }
                })

                // Default Terrain: DTM10
                var hoydeDTM10TerrainProviderCreationFunction = await Cesium.ArcGISTiledElevationTerrainProvider.fromUrl(
                    "https://elevation3d.arcgis.com/arcgis/rest/services/WorldElevation3D/Terrain3D/ImageServer"
                )

                // Create viewer
                var viewer = await new Cesium.Viewer('cesiumContainer', {
                    //terrainProvider: Cesium.createWorldTerrain({ requestVertexNormals: true }), //worldTerrainProvider,
                    //terrainProvider: await Cesium.CesiumTerrainProvider.fromIonAssetId(1740727),
                    terrainProvider: hoydeDTM10TerrainProviderCreationFunction,
                    selectedImageryProviderViewModel: ESRIImageryProviderViewModel

                });


     
                // Delete tha bing maps providers from the baseLayerPicker
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.splice(0, 3);
                // Delete other maps that we dont need
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.splice(1, 2);
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.splice(2, 6);
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.splice(0, 2);
                // Delete terrains we dont use
                await viewer.baseLayerPicker.viewModel.terrainProviderViewModels.splice(0, 1);
                // Delete 2D/3D switch
                var sceneModePicker = document.getElementsByClassName('cesium-sceneModePicker-wrapper')[0];
                if (sceneModePicker) {
                    sceneModePicker.parentNode.removeChild(sceneModePicker);
                }



                // Add ArcGIS World Imagery Provider
                await viewer.baseLayerPicker.viewModel.imageryProviderViewModels.push(ESRIImageryProviderViewModel);

                // Add Imagery providers
                await add_geonorge_imagery_providers(viewer);


                // Terrains
                // Høyde DTM 1m
                var hoydeDTM1TerrainProvider = new Cesium.ProviderViewModel({
                    name: 'Høyde DTM 1m', // The name displayed in the baseLayerPicker
                    tooltip: 'Høydevariasjon i terrengmodellen innenfor skjermutsnitt', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1622003836.png?w=200', // URL to an icon image
                    category: 'Høydedata.no',
                    creationFunction: function () {
                        return Cesium.CesiumTerrainProvider.fromIonAssetId(1849491, {
                            requestVertexNormals: true
                        })
                    },
                });
                viewer.baseLayerPicker.viewModel.terrainProviderViewModels.push(hoydeDTM1TerrainProvider);




                // Default Terrain: Høyde DTM 10m
                var hoydeDTM10TerrainProvider = await new Cesium.ProviderViewModel({
                    name: 'Høyde DTM 10m', // The name displayed in the baseLayerPicker
                    tooltip: 'Høydevariasjon i terrengmodellen innenfor skjermutsnitt', // Tooltip text
                    iconUrl: 'https://insoft.sirv.com/TouchTime/html/2023/6/clipboard_2023-06-1622003836.png?w=200', // URL to an icon image
                    category: 'Høydedata.no',
                    creationFunction: function () {
                        return hoydeDTM10TerrainProviderCreationFunction
                    }
                });
                // Høyde DTM 10m
                viewer.baseLayerPicker.viewModel.terrainProviderViewModels.push(hoydeDTM10TerrainProvider);


                // Disable transparency of the terrain
                viewer.scene.globe.depthTestAgainstTerrain = false




                return viewer;


            }


            // ------------------------------- read_gpx_file ------------------------------- //
            async function read_gpx_file(file) {
                var response = await fetch(file);
                var xml_content = await response.text();
                
                return xml_content;
            }


            // ----------------------------- correct_elevation ----------------------------- //
            // Correct elevations under ground
            async function correct_elevation(trkElement, viewer) {

                var helicopter_words = ['Spor flanke', 'Lag 1-2', '15'];
                var trkName = trkElement.getElementsByTagName("name")[0].textContent
                var is_helicopter = string_contains_any(trkName, helicopter_words)

                var trkPoints = trkElement.getElementsByTagName("trkpt")
                var terrain = []
                var elevation = []
                for (let i = 0; i < trkPoints.length; i++) {
                    var trkPoint = await trkPoints[i]
                    var lat = await trkPoint.getAttribute("lat")
                    var lon = await trkPoint.getAttribute("lon")
                    var ele = await parseFloat(trkPoint.getElementsByTagName("ele")[0].textContent)

                    await terrain.push(Cesium.Cartographic.fromDegrees(lon, lat));
                    await elevation.push(ele)

                }
                // Load the information from the terrain
                var terrainSample = await Cesium.sampleTerrain(viewer.terrainProvider, 13, terrain);

                if (is_helicopter) {
                    for (let i = 0; i < trkPoints.length; i++) {
                        // Update track elevation
                        if (elevation[i] < terrainSample[i].height) {
                            trkPoints[i].getElementsByTagName("ele")[0].textContent = String(terrainSample[i].height + 2);
                        }
                    }
                } else {
                    for (let i = 0; i < trkPoints.length; i++) {
                        // Update track elevation
                        trkPoints[i].getElementsByTagName("ele")[0].textContent = String(terrainSample[i].height + 2);
                    }
                }



                return trkElement;

            }


            // ----------------------------- string_contains_any ------------------------------ //
            function string_contains_any(string, list) {
                for (let i = 0; i < list.length; i++) {
                    if (string.includes(list[i])) {
                        return true;
                    }
                }
                return false;
            }


            // ----------------------------- create_czml_path ------------------------------ //
            async function create_czml_path(trkElement) {
                var gpxElementCZML = []

                // Auxiliary variables
                var timeVector = trkElement.getElementsByTagName("time")
                var timeStart = timeVector[0].textContent;;
                var timeEnd = timeVector[timeVector.length - 1].textContent;
                var timeStartDate = new Date(timeStart);
                var timeEndDate = new Date(timeEnd);
                var trackDurationSeconds = Math.abs(timeEndDate - timeStartDate) / 1000;


                var czmlName = trkElement.getElementsByTagName("name")[0].textContent;
                var czmlTimeInterval = timeStart + '/' + timeEnd;
                var czmlCurrentTime = timeStart;
                var czmlAvailability = timeStart + '/' + timeEnd //;czmlTimeInterval;
                var czmlTrailTime = trackDurationSeconds; //Math.abs(timeEndDate2 - timeStartDate) / 1000; //
                var czmlPositionEpoch = timeStart;
                var czmlPositions = []


                // Generate positions vector
                var trkpt = await trkElement.getElementsByTagName("trkpt")

                for (let i = 0; i < trkpt.length; i++) {

                    var lat = await parseFloat(trkpt[i].getAttribute('lat'));
                    var lon = await parseFloat(trkpt[i].getAttribute('lon'));
                    var ele = await parseFloat(trkpt[i].querySelector('ele').textContent);
                    var time = await new Date(trkpt[i].querySelector('time').textContent);
                    var timeDiff = await Math.abs(time - timeStartDate) / 1000;
                    await czmlPositions.push(timeDiff, lon, lat, ele)
                }


                // Create CZML 
                var gpxElementCZML = await [
                    {
                        id: "document",
                        name: czmlName,
                        version: "1.0",
                        clock: {
                            interval: czmlTimeInterval,
                            currentTime: czmlCurrentTime,
                            multiplier: 1,
                        },
                    },
                    {
                        //id: "path",
                        name: czmlName,
                        //description:
                        availability: czmlAvailability,
                        path: {
                            leadTime: 1,
                            trailTime: czmlTrailTime, //mission duration in seconds
                            resolution: 5,
                        },

                        position: {
                            epoch: czmlPositionEpoch,
                            "cartographicDegrees": czmlPositions
                        }
                    }
                ];



                return gpxElementCZML;

            }


            // ------------------------------ parse_gpx_file ------------------------------- //
            async function parse_gpx_file(xml_string, viewer) {

                console.log('Parsing GPX File starting...')

                var gpxElements = []
                var xmlElement = [];
                var xmlElementString = [];


                //xml_string = await xml_string.replace(/<ele>/g, '<ele>')
                //xml_string = await xml_string.replace(/<\/ele>/g, '"</ele>')


                // Parse GPX File
                var gpxParser = await new DOMParser();
                var gpxDoc = await gpxParser.parseFromString(xml_string, "application/xml");

                // Get all wpt elements
                var wptElements = await gpxDoc.getElementsByTagName("wpt");
                for (let i = 0; i < wptElements.length; i++) {

                    var gpxString = await '<gpx> ' + wptElements[i].outerHTML + '</gpx>';
                    await xmlElementString.push(gpxString);
                    await xmlElement.push(wptElements[i]);

                    var gpxElementDoc = await gpxParser.parseFromString(gpxString, "application/xml");
                    await gpxElements.push(Cesium.GpxDataSource.load(gpxElementDoc));
                }

                // Get all trk elements and correct elevations
                var trkElements = Array.from(await gpxDoc.getElementsByTagName("trk"));
                for (let i = 0; i < trkElements.length; i++) {
                    if (trkElements[i].getElementsByTagName("ele").length !== 0) {
                        trkElements[i] = await correct_elevation(trkElements[i], viewer);
                    }
                }

                // Get Area elements
                for (let i = 0; i < trkElements.length; i++) {
                    if (trkElements[i].getElementsByTagName("time").length === 0) {
                        var gpxString = await '<gpx> ' + trkElements[i].outerHTML + '</gpx>'
                        await xmlElementString.push(gpxString);
                        await xmlElement.push(trkElements[i]);

                        var gpxElementDoc = await gpxParser.parseFromString(gpxString, "application/xml");

                        // If there is no elevation, clamp it to the ground
                        if (trkElements[i].getElementsByTagName("ele").length === 0) {
                            await gpxElements.push(Cesium.GpxDataSource.load(gpxElementDoc, { clampToGround: true, }));
                        }
                        else {
                            await gpxElements.push(Cesium.GpxDataSource.load(gpxElementDoc));
                        }
                    }
                }


                // Get Tracks elements
                for (let i = 0; i < trkElements.length; i++) {
                    if (trkElements[i].getElementsByTagName("time").length !== 0) {

                        var gpxString = await '<gpx> ' + trkElements[i].outerHTML + '</gpx>'
                        await xmlElementString.push(gpxString);
                        await xmlElement.push(trkElements[i]);

                        //var gpxElementDoc = gpxParser.parseFromString(gpxString, "application/xml");
                        var gpxElementCZML = await create_czml_path(trkElements[i])
                        await gpxElements.push(Cesium.CzmlDataSource.load(gpxElementCZML));

                    }
                }

                console.log('Parsing GPX File finished.')

                return { xmlElement, xmlElementString, gpxElements };

            }


            // ----------------------------- parse_gpx_content ----------------------------- //
            async function parse_gpx_content(xml_string, viewer) {

                var xmlElementArray = await [];
                var xmlElementStringArray = await [];
                var gpxElementsArray = await [];

                if (xml_string === '') {
                    return { xmlElementArray, xmlElementStringArray, gpxElementsArray };
                }

                // Parse gpx file
                var { xmlElement, xmlElementString, gpxElements } = await parse_gpx_file(xml_string, viewer);
                // Load arrays
                await xmlElementArray.push(...xmlElement);
                await xmlElementStringArray.push(...xmlElementString);
                await gpxElementsArray.push(...gpxElements);


                return { xmlElementArray, xmlElementStringArray, gpxElementsArray };

            }


            // ------------------------------ parse_gpx_files ------------------------------- //
            async function parse_gpx_files(gpx_file_names, viewer) {

                var xmlElementArray = await [];
                var xmlElementStringArray = await [];
                var gpxElementsArray = await [];

                for (let i = 0; i < gpx_file_names.length; i++) {
                    // Read gpx file
                    var xml_string = await read_gpx_file(gpx_file_names[i]);
                    // Parse gpx file
                    var { xmlElement, xmlElementString, gpxElements } = await parse_gpx_file(xml_string, viewer);
                    // Load arrays
                    await xmlElementArray.push(...xmlElement);
                    await xmlElementStringArray.push(...xmlElementString);
                    await gpxElementsArray.push(...gpxElements);
                }

                return { xmlElementArray, xmlElementStringArray, gpxElementsArray };

            }


            // ------------------------- initialize_simulation ----------------------------- //
            async function initialize_simulation(viewer, xmlElement, gpxElements){

                // Initialization if there are no gpx files
                if (gpxElements.length === 0) {

                    var initialLatitude = 62.380114507596936;
                    var initialLongitude = 6.569782380580388;
                    var initialHeight = 0;

                    // Position camera in the starting point of the first track
                    viewer.camera.flyTo({
                        destination: Cesium.Cartesian3.fromDegrees(initialLongitude, initialLatitude, initialHeight + 2000),
                        orientation: {
                            heading: Cesium.Math.toRadians(0.0),
                            pitch: Cesium.Math.toRadians(-90.0),
                        }
                    });

                    return { viewer }
                }



                // Wait for data sources to resolved
                var dataSource = await Promise.all(gpxElements)
                    .catch(function (error) {
                        //Display any errrors encountered while loading.
                        window.alert(error);
                    });
            

                // Set up settings for each track before loading them in the viewer
                var indexEarliestTrack = 0;
                var indexEarliestEntity = 0;
                var animationStartDateTime = Cesium.JulianDate.fromDate(new Date("2300-01-01")); 
                var animationStopDateTime = Cesium.JulianDate.fromDate(new Date("1900-01-01"));
                for (let i = 0; i < gpxElements.length; i++) {
                
                    var entities = dataSource[i].entities.values;

                    for (let j = 0; j < entities.length; j++) {
                        track = entities[j];
                    
                        // Load track name
                        var track_name = xmlElement[i].getElementsByTagName("name")[0];
                        if (track_name){
                            if (track.polyline) {
                                track.name = 'Area: ' + xmlElement[i].getElementsByTagName("name")[0].textContent;
                            }else if (track.path){
                                track.name = 'Track: ' + xmlElement[i].getElementsByTagName("name")[0].textContent;                    
                            }else{
                                track.name = 'Wpt: ' + xmlElement[i].getElementsByTagName("name")[0].textContent;
                            }
                        
                        }

                        // Polylines
                        var line_color = new Cesium.Color(Math.random(), Math.random(), Math.random(), 1.0);
                        if (track.polyline) {
                        
                            // Line color
                            track.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                                color: line_color, 
                                outlineWidth: 1,
                                outlineColor: Cesium.Color.BLACK,
                            });
                            //Line width
                            track.polyline.width = 3;
                        }
                        // Path
                        if (track.path) {
                            // Line color
                            track.path.material = new Cesium.PolylineOutlineMaterialProperty({
                                color: line_color, 
                                outlineWidth: 1,
                                outlineColor: Cesium.Color.BLACK,
                            });
                            //Line width
                            track.path.width = 3;           
                        
                        }
                        // Billboard color
                        if (track.billboard) {

                            // Set billboard elevation:
                            let ellipsoid = await viewer.scene.globe.ellipsoid;
                            let cartographic = await Cesium.Cartographic.fromCartesian(track.position._value, ellipsoid);

                            let terrainSample = await Cesium.sampleTerrain(viewer.terrainProvider, 14, [cartographic]);
                            cartographic.height = await terrainSample[0].height;
                            track.position._value = await Cesium.Cartographic.toCartesian(cartographic, ellipsoid);
                            
                        }

                    
                        // Load initial and stop time of the 3D animation (this is in JulianDate units)
                        if (track.availability) {
                            var trackStartDateTime = track.availability.start;
                            var trackStopDateTime = track.availability.stop;

                            if (trackStartDateTime < animationStartDateTime) {
                                animationStartDateTime = trackStartDateTime;  
                                indexEarliestTrack = i;
                                indexEarliestEntity = j;
                            }
                            if (trackStopDateTime > animationStopDateTime) {
                                animationStopDateTime = trackStopDateTime;  
                            }
                        }
                    

                    }
                }

                // Set trailTime and availability to the whole mission:
                for (let i = 0; i < gpxElements.length; i++) {
                    var track = await dataSource[i].entities.values[0];
                    if (track.path){
                    
                        var pathTrailTime = await Cesium.JulianDate.secondsDifference(animationStopDateTime, track.availability.start)
                        track.path.trailTime._value = await pathTrailTime;
                        track._availability._intervals[0].stop = await animationStopDateTime;
                    }
                }
                var missionDurationSeconds = await Cesium.JulianDate.secondsDifference(animationStopDateTime, animationStartDateTime)
                console.log('Mission Duration in Hours: ', missionDurationSeconds/3600)
            


                //-------------------------- Set up the viewer ---------------------------- //
                // Load gpxElements in the map
                for (let k = 0; k < gpxElements.length; k++) {
                    await viewer.dataSources.add(dataSource[k]);    
                }


                // Load initial position for the earliest track.
                var initialLatitude = 0;
                var initialLongitude = 0;
                var initialHeight = 0;

                track = dataSource[indexEarliestTrack].entities.values[indexEarliestEntity]
                if (track.polyline) {
                    var initialPosition = track.polyline.positions.getValue()[0];

                }else if (track.path){
                    var lat = await parseFloat(xmlElement[indexEarliestTrack].getElementsByTagName("trkpt")[0].getAttribute('lat'));
                    var lon = await parseFloat(xmlElement[indexEarliestTrack].getElementsByTagName("trkpt")[0].getAttribute('lon'));
                    var ele = await parseFloat(xmlElement[indexEarliestTrack].getElementsByTagName("trkpt")[0].querySelector('ele').textContent);
                    var initialPosition = Cesium.Cartesian3.fromDegrees(lon, lat, ele)
                }else{
                    var initialPosition = track.position.getValue();
                }

                var initialPositionCartographic = Cesium.Cartographic.fromCartesian(initialPosition);
                initialLatitude = Cesium.Math.toDegrees(initialPositionCartographic.latitude);
                initialLongitude = Cesium.Math.toDegrees(initialPositionCartographic.longitude);
                initialHeight = initialPositionCartographic.height;

                console.log('Initial position: ', initialLatitude, initialLongitude, initialHeight)
            

                // Position camera in the starting point of the first track
                viewer.camera.flyTo({
                    destination : Cesium.Cartesian3.fromDegrees(initialLongitude, initialLatitude, initialHeight + 4000),
                    orientation : {
                        heading : Cesium.Math.toRadians(0.0),
                        pitch : Cesium.Math.toRadians(-90.0),
                    }
                });

                // Adjust Animation time range
                viewer.clock.startTime = animationStartDateTime.clone();
                viewer.clock.currentTime = animationStartDateTime.clone();
                viewer.clock.stopTime = animationStopDateTime.clone();
                console.log('Animation Start: ', Cesium.JulianDate.toGregorianDate(animationStartDateTime))
                console.log('Animation Stop: ',  Cesium.JulianDate.toGregorianDate(animationStopDateTime))
            
            
                viewer.timeline.zoomTo(animationStartDateTime, animationStopDateTime)

            

                return {viewer};

            }


            // ------------------------- set_hrs_resource ----------------------------- //
            async function set_hrs_resource(viewer){
                // Select only the paths datasources
        
                var NRH_words = ['Hund', 'NRH'];
                var RKH_words = ['RKH', 'RK'];
                var NLA_words = ['Spor flanke', 'Lag 1-2'];
                var S330_words = ['15'];


                var datasources = viewer.dataSources._dataSources 
                var tracks = [];
                for (let i = 0; i < datasources.length; i++) {
                
                    var track = datasources[i].entities.values[0]

                    if(track.path){
                
                        // Set HRS Resource
                        if (string_contains_any(track.name, NRH_words)){
                            track.resource = 'NRH';
                        }else if(string_contains_any(track.name, RKH_words)){
                            track.resource = 'RKH';
                        }else if(string_contains_any(track.name, NLA_words)){
                            track.resource = 'NLA';
                        } else if (string_contains_any(track.name, S330_words)) {
                            track.resource = '330';
                        }else{
                            track.resource = 'Others';
                        }

                    }
                }
            }

        
            // ------------------------- create_billboards ----------------------------- //
            async function create_billboards(viewer){
                let datasources = viewer.dataSources._dataSources 
                for (let i = 0; i < datasources.length; i++) {
                
                    var track = datasources[i].entities.values[0]

                    if(track.path){

                        // Load icon for waypoint
                        if (track.resource === 'NRH'){
                            var billboardImage = "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-0411502561.png?w=800&scale.option=noup";
                            var billboardScale = 1.0;
                        } else if (track.resource === 'RKH'){
                            var billboardImage = "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-0411512240.png?w=800&scale.option=noup";
                            var billboardScale = 1.0;
                        } else if (track.resource === 'NLA'){
                            var billboardImage = "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-0411460040.png?w=400&scale.option=noup";
                            var billboardScale = 2;
                        } else if (track.resource === '330') {
                            var billboardImage = "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-2023021324.png?w=400&scale.option=noup";
                            var billboardScale = 3;
                        } else{
                            var billboardImage = "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-0411525329.png?w=800&scale.option=noup";
                            var billboardScale = 1.0;
                        }


                        // Create billboard according to the resource
                        track.billboard = {
                            image: billboardImage,
                            scale: billboardScale,
                            width: 25,
                            height: 25,
                            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                            //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0),
                            scaleByDistance: new Cesium.NearFarScalar(0, 1, 1000, 1)
                        }
                
                    }
                }


            }


            // -------------------- create_waypoints_list_container ------------------------ //
            function create_waypoints_list_container(viewer){
            
                // Select the type of datasource
                let datasources = viewer.dataSources._dataSources 
                let tracks = [];
                for (let i = 0; i < datasources.length; i++) {
                    if(!datasources[i].entities.values[0].polyline && 
                       !datasources[i].entities.values[0].path){
                        tracks.push(datasources[i]);
                    }
                }
            
                var waypointsListContainer = document.createElement('div');
                waypointsListContainer.id = 'waypointsListContainer';
                waypointsListContainer.classList = 'dataSourceList';

                // Create trackContainer for each track
                for (let i = 0; i < tracks.length; i++) {
                
                    let track = tracks[i];
                    track.show = true;
                    
                    // Create checkbox
                    let checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.checked = track.show;
                    checkbox.className = "mapView3dCustomCheckBox";
                    checkbox.addEventListener('change', function() {
                        track.show = checkbox.checked;
                    });

                    // Create label for the checkbox with the track name
                    let label = document.createElement('label');
                    label.textContent = track.entities.values[0].name;
                    label.style.display = 'inline-block';
                    label.style.verticalAlign = 'middle';
                    label.style.color = 'white';
                
                    // Create container for the checkbox and label
                    let trackContainer = document.createElement('div');
                    trackContainer.className = 'dataSourceItem';
                
                
                    // Add checkbox and label to track list container
                    trackContainer.appendChild(checkbox);
                    trackContainer.appendChild(label);
                    
                    waypointsListContainer.appendChild(trackContainer);

                

                }

                
                // Create "Toggle all" checkbox
                let toggleAllCheckbox = document.createElement('input');
                toggleAllCheckbox.type = 'checkbox';
                toggleAllCheckbox.checked = true;
                toggleAllCheckbox.className = "mapView3dCustomCheckBox";
                toggleAllCheckbox.addEventListener('change', function() {
                    let checkboxList = document.querySelectorAll('#waypointsListContainer input[type="checkbox"]');
                
                    for (let i = 0; i < checkboxList.length; i++) {
                        checkboxList[i].checked = !toggleAllCheckbox.checked;
                        if (i > 0){
                            tracks[i-1].show = !toggleAllCheckbox.checked;
                        }
                    
                    }   
                    toggleAllCheckbox.checked = !toggleAllCheckbox.checked

                });

                // Create label for the "Toggle all" checkbox
                let toggleAllLabel = document.createElement('label');
                toggleAllLabel.textContent = 'Select all';
                toggleAllLabel.style.display = 'inline-block';
                toggleAllLabel.style.verticalAlign = 'middle';
                toggleAllLabel.style.color = 'white';

                // Create container for the "Toggle all" checkbox and label
                let toggleAllContainer = document.createElement('div');
                toggleAllContainer.className = 'dataSourceItem';

                toggleAllContainer.appendChild(toggleAllCheckbox);
                toggleAllContainer.appendChild(toggleAllLabel);
                
                waypointsListContainer.insertBefore(toggleAllContainer, waypointsListContainer.firstChild);


                // Create the open/close button
                //let waypointsListOpenCloseButton = document.getElementById('waypointsListOpenCloseButton');
                let waypointsListOpenCloseButton  = document.createElement('button')
                waypointsListOpenCloseButton.id = 'waypointsListOpenCloseButton';
                waypointsListOpenCloseButton.classList = 'cesium-button';

                waypointsListOpenCloseButton.addEventListener('click', function() {
                    waypointsListContainer.classList.toggle('appear');
                    waypointsListOpenCloseButton.classList.toggle('off')
                });

                let tooltip = add_tooltip(waypointsListOpenCloseButton, 'Enable/dissable Waypoints')

                // Close container when I click on the other menu lists only
                /*window.addEventListener('click', function (event) {
                    const target = event.target;
                    let areasListOpenCloseButton = document.getElementById('areasListOpenCloseButton');
                    let tracksListOpenCloseButton = document.getElementById('tracksListOpenCloseButton');
                    const otherButtonsClicked = target === areasListOpenCloseButton || target === tracksListOpenCloseButton;
                    if (otherButtonsClicked) {
                        waypointsListContainer.classList.remove('appear');
                    }
                });*/

                // Close container when I click outside
                window.addEventListener('click', function (event) {
                    const target = event.target;
                    const container = document.getElementById('waypointsListContainer');
                    const isButtonClicked = target.id === 'waypointsListOpenCloseButton';
                    const isClickedOutsideContainer = !container.contains(target);
                    if (isClickedOutsideContainer && !isButtonClicked) {
                
                        container.classList.remove('appear');
                    }
                });

                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(waypointsListOpenCloseButton);
                cesiumViewerContainer.appendChild(waypointsListContainer);

            }


            // -------------------- create_areas_list_container ------------------------ //
            function create_areas_list_container(viewer){
            
                // Select the type of datasource
                let datasources = viewer.dataSources._dataSources 
                let tracks = [];
                for (let i = 0; i < datasources.length; i++) {
                    if(datasources[i].entities.values[0].polyline){
                        tracks.push(datasources[i]);
                    }
                }
            

                var areasListContainer = document.createElement('div');
                areasListContainer.id = 'areasListContainer';
                areasListContainer.classList = 'dataSourceList';


                // Create trackContainer for each track
                for (let i = 0; i < tracks.length; i++) {
                
                    let track = tracks[i];
                    track.show = true;
                    
                    // Create checkbox
                    let checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.checked = track.show;
                    checkbox.className = "mapView3dCustomCheckBox";
                    checkbox.addEventListener('change', function() {
                        track.show = checkbox.checked;
                    });

                    // Create label for the checkbox with the track name
                    let label = document.createElement('label');
                    label.textContent = track.entities.values[0].name;
                    label.style.display = 'inline-block';
                    label.style.verticalAlign = 'middle';
                    label.style.color = 'white';
                
                    // Create container for the checkbox and label
                    let trackContainer = document.createElement('div');
                    trackContainer.className = 'dataSourceItem';
                    
                    // Add checkbox and label to track list container
                    trackContainer.appendChild(checkbox);
                    trackContainer.appendChild(label);

                    areasListContainer.appendChild(trackContainer);

                }

                
                // Create "Toggle all" checkbox
                let toggleAllCheckbox = document.createElement('input');
                toggleAllCheckbox.type = 'checkbox';
                toggleAllCheckbox.checked = true;
                toggleAllCheckbox.className = "mapView3dCustomCheckBox";
                toggleAllCheckbox.addEventListener('change', function() {
                    let checkboxList = document.querySelectorAll('#areasListContainer input[type="checkbox"]');
                    for (let i = 0; i < checkboxList.length; i++) {
                        checkboxList[i].checked = !toggleAllCheckbox.checked;
                        if (i > 0){
                            tracks[i-1].show = !toggleAllCheckbox.checked;
                        }   
                    }   
                    toggleAllCheckbox.checked = !toggleAllCheckbox.checked
                });

                // Create label for the "Toggle all" checkbox
                let toggleAllLabel = document.createElement('label');
                toggleAllLabel.textContent = 'Select all';
                toggleAllLabel.style.display = 'inline-block';
                toggleAllLabel.style.verticalAlign = 'middle';
                toggleAllLabel.style.color = 'white';

                // Create container for the "Toggle all" checkbox and label
                let toggleAllContainer = document.createElement('div');
                toggleAllContainer.className = 'dataSourceItem';

                toggleAllContainer.appendChild(toggleAllCheckbox);
                toggleAllContainer.appendChild(toggleAllLabel);
                areasListContainer.insertBefore(toggleAllContainer, areasListContainer.firstChild);


                // Create the open/close button
                let areasListOpenCloseButton  = document.createElement('button')
                areasListOpenCloseButton.id = 'areasListOpenCloseButton';
                areasListOpenCloseButton.classList = 'cesium-button';

                let tooltip = add_tooltip(areasListOpenCloseButton, 'Enable/dissable Areas')

                areasListOpenCloseButton.addEventListener('click', function() {
                    areasListContainer.classList.toggle('appear');
                });

                

                // Close container when I click outside
                window.addEventListener('click', function (event) {
                    const target = event.target;
                    const container = document.getElementById('areasListContainer');
                    const isButtonClicked = target.id === 'areasListOpenCloseButton';
                    const isClickedOutsideContainer = !container.contains(target);
                    if (isClickedOutsideContainer && !isButtonClicked) {
                
                        container.classList.remove('appear');
                    }
                });

                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(areasListOpenCloseButton);
                cesiumViewerContainer.appendChild(areasListContainer);


            }


            // --------------------- add_track_to_filter_list --------------------------- //
            function add_track_to_filter_list(track) {

                let tracksListContainer = document.getElementById('tracksListContainer');
                
                // Create trackContainer for each track  
                track.show = true;

                // Create checkbox
                let checkbox = document.createElement('input');
                checkbox.type = 'checkbox';
                checkbox.checked = track.show;
                checkbox.className = "mapView3dCustomCheckBox";
                checkbox.addEventListener('change', function () {
                    track.show = checkbox.checked;
                });

                // Create label for the checkbox with the track name
                let label = document.createElement('label');
                label.textContent = track.name;
                label.style.display = 'inline-block';
                label.style.verticalAlign = 'middle';
                label.style.color = 'white';

                // Create container for the checkbox and label
                let trackContainer = document.createElement('div');
                trackContainer.className = 'dataSourceItem';

                // Add checkbox and label to track list container
                trackContainer.appendChild(checkbox);
                trackContainer.appendChild(label);


                tracksListContainer.appendChild(trackContainer);


            }


            // --------------------- create_tracks_list_container -------------------------- //
            async function create_tracks_list_container(viewer){
            
                // Select the type of datasource
                let datasources = viewer.dataSources._dataSources 
                let tracks = [];
                for (let i = 0; i < datasources.length; i++) {
                    if(datasources[i].entities.values[0].path){
                        tracks.push(datasources[i]);
                    }
                }
            
                var tracksListContainer = document.createElement('div');
                tracksListContainer.id = 'tracksListContainer';
                tracksListContainer.classList = 'dataSourceList';

                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(tracksListContainer);



                // Create trackContainer for each track
                for (let i = 0; i < tracks.length; i++) {
                    let track = await tracks[i].entities.values[0];
                    add_track_to_filter_list(track)

                }

                
                // Create "Toggle all" checkbox
                let toggleAllCheckbox = document.createElement('input');
                toggleAllCheckbox.type = 'checkbox';
                toggleAllCheckbox.checked = true;
                toggleAllCheckbox.className = "mapView3dCustomCheckBox";
                toggleAllCheckbox.addEventListener('change', function() {

                    let checkboxList = document.querySelectorAll('#tracksListContainer input[type="checkbox"]');

                    let tracks = [];
                    for (let i = 0; i < datasources.length; i++) {
                        if (datasources[i].entities.values[0].path) {
                            tracks.push(datasources[i]);
                        }
                    }
                
                    for (let i = 1; i < checkboxList.length; i++) {     
                        let track = tracks[i-1].entities.values[0];

                        checkboxList[i].checked = toggleAllCheckbox.checked;
                        track.show = toggleAllCheckbox.checked;
                    }   
                    //toggleAllCheckbox.checked = !toggleAllCheckbox.checked
                
                    //Switch all the resources buttons
                    let NRHButton = document.getElementById('NRHButton');
                    let RKHButton = document.getElementById('RKHButton');
                    let NLAButton = document.getElementById('NLAButton');
                    let OthersButton = document.getElementById('OthersButton');
                
                    if(!toggleAllCheckbox.checked){
                        NRHButton.classList.add('off');
                        RKHButton.classList.add('off');
                        NLAButton.classList.add('off');
                        OthersButton.classList.add('off');
                    }else{
                        NRHButton.classList.remove('off');
                        RKHButton.classList.remove('off');
                        NLAButton.classList.remove('off');
                        OthersButton.classList.remove('off');
                    }

                });

                // Create label for the "Toggle all" checkbox
                let toggleAllLabel = document.createElement('label');
                toggleAllLabel.textContent = 'Select all';
                toggleAllLabel.style.display = 'inline-block';
                toggleAllLabel.style.verticalAlign = 'middle';
                toggleAllLabel.style.color = 'white';

                // Create container for the "Toggle all" checkbox and label
                let toggleAllContainer = document.createElement('div');
                toggleAllContainer.className = 'dataSourceItem';

                toggleAllContainer.appendChild(toggleAllCheckbox);
                toggleAllContainer.appendChild(toggleAllLabel);

                tracksListContainer.insertBefore(toggleAllContainer, tracksListContainer.firstChild);


                // Create the open/close button
                let tracksListOpenCloseButton  = document.createElement('button')
                tracksListOpenCloseButton.id = 'tracksListOpenCloseButton';
                tracksListOpenCloseButton.classList = 'cesium-button';

                let tooltip = add_tooltip(tracksListOpenCloseButton, 'Enable/dissable Tracks')

                tracksListOpenCloseButton.addEventListener('click', function() {
                    tracksListContainer.classList.toggle('appear');
                });


                // Close container when I click outside
                window.addEventListener('click', function (event) {
                    const target = event.target;
                    const container = document.getElementById('tracksListContainer');
                    const isButtonClicked = target.id === 'tracksListOpenCloseButton';
                    const isClickedOutsideContainer = !container.contains(target);
                    if (isClickedOutsideContainer && !isButtonClicked) {
                
                        container.classList.remove('appear');
                    }
                });


                cesiumViewerContainer.appendChild(tracksListOpenCloseButton);
                


            }

        
            // ------------------------- show_tooltip -------------------------------- //
            var toolTipsTimeouts = [];
            function show_tooltip(tooltip, event) {
                    var x = event.clientX;
                    var y = event.clientY;
                    tooltip.style.left = (x + 10) + 'px';
                    tooltip.style.top = (y + 10) + 'px';
                
                    var delayInMilliseconds = 1000;
                    var timeoutID = setTimeout(function() {
                        tooltip.style.visibility = 'visible';
                    }, delayInMilliseconds);
                    toolTipsTimeouts.push(timeoutID);
            }


            // ------------------------- hide_tooltip -------------------------------- //
            function hide_tooltip(tooltip) {
                for (var i = 0; i < toolTipsTimeouts.length; i++) {
                    clearTimeout(toolTipsTimeouts[i]);
                }
                // Clear the timeouts array
                toolTipsTimeouts = [];
                tooltip.style.visibility = 'hidden';
            }


            // ------------------------- add_tooltip -------------------------------- //
            function add_tooltip(button, tooltipText) {
   
                var tooltip = document.createElement('span');
                tooltip.className = 'mapView3dTooltip';
                tooltip.textContent = tooltipText;
                button.appendChild(tooltip);

                button.addEventListener('mouseover', function(event) {
                    if (!('ontouchstart' in window)) {
                        show_tooltip(tooltip, event);
                    }
                });
                button.addEventListener('mouseout', function() {
                    hide_tooltip(tooltip);
                });            
            
                return tooltip

            }

        
            // --------------------- create_tracks_list_container -------------------------- //
            function formatDateDifference(startDate, endDate) {
                var diff = Math.abs(endDate - startDate); // Calculate the difference in milliseconds

                var days = Math.floor(diff / (1000 * 60 * 60 * 24)); // Calculate the number of days
                diff -= days * (1000 * 60 * 60 * 24); // Remove the days from the difference

                var hours = Math.floor(diff / (1000 * 60 * 60)); // Calculate the number of hours
                diff -= hours * (1000 * 60 * 60); // Remove the hours from the difference

                var minutes = Math.floor(diff / (1000 * 60)); // Calculate the number of minutes

                // Build the formatted string
                var formattedString = "";
                if (days > 0) {
                    formattedString += days + " days ";
                }
                if (hours > 0) {
                    formattedString += hours + " hours ";
                }
                if (minutes > 0) {
                    formattedString += minutes + " minutes";
                }

                return formattedString;
            }



            // ----------------------- create_3Dtileset_button ----------------------------- //
            function create_3Dtileset_button(viewer){

                // Button to toggle 3D tilesets
                let button = document.createElement('button')
                button.id = 'tilesets3DButton';
                button.classList = 'cesium-button cesium-toolbar-button';
                
                
                button.addEventListener('click', function() {
                    button.classList.toggle('on');
                
                    var basePath = 'https://assets.ion.cesium.com/asset_depot/96188'
                    var tileset3DExists = false
                
                    var primitives = viewer.scene.primitives
                    for (let i = 0; i < primitives.length; i++) {
                        let primitive = primitives.get(i);
                        if (primitive._url && primitive._url.includes(basePath)){
                            tileset3DExists = true;
                            primitives.remove(primitive);
                        }
                    }
                    if(!tileset3DExists){
                        // Add the OSM buildings primitive    
                        let buildingsPrimitive = viewer.scene.primitives.add(Cesium.createOsmBuildings());
                    }
                
                
                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Toggle 3D buildings')

                // Place the button in Cesium's toolbar
                var cesiumToolbar = document.getElementsByClassName('cesium-viewer-toolbar')[0]
                var homeButton = document.getElementsByClassName('cesium-button cesium-toolbar-button cesium-home-button')[0]
                cesiumToolbar.insertBefore(button, homeButton.nextSibling);
            
            }


            // ------------------ create_terrain_transparancy_button -------------------------- //
            function create_terrain_transparancy_button(viewer){

                // Button to toggle 3D tilesets
                let button = document.createElement('button')
                button.id = 'terrainTransparancyButton';
                button.classList = 'cesium-button cesium-toolbar-button';
                
                button.addEventListener('click', function() {
                    button.classList.toggle('on');
                    viewer.scene.globe.depthTestAgainstTerrain = !viewer.scene.globe.depthTestAgainstTerrain
                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Toggle terrain transparency')
            
                // Place the button in Cesium's toolbar
                var cesiumToolbar = document.getElementsByClassName('cesium-viewer-toolbar')[0]
                var homeButton = document.getElementsByClassName('cesium-button cesium-toolbar-button cesium-home-button')[0]
                cesiumToolbar.insertBefore(button, homeButton.nextSibling);

            }


            // --------------------- create_google_earth_button ----------------------------- //
            function create_google_earth_button(viewer){

                // Button to toggle 3D tilesets
                let button = document.createElement('button')
                button.id = 'googleEarthButton';
                button.classList = 'cesium-button cesium-toolbar-button';

                button.addEventListener('click', function() {
                    button.classList.toggle('on');
                
                    var basePath = 'https://tile.googleapis.com/v1/3dtiles'
                    var googleEarthLayerExists = false
                
                    var primitives = viewer.scene.primitives
                    for (let i = 0; i < primitives.length; i++) {
                        let primitive = primitives.get(i);
                        if (primitive._url && primitive._url.includes(basePath)){
                            googleEarthLayerExists = true;
                            primitives.remove(primitive);
                        }
                    }
                    if(!googleEarthLayerExists){
                        // Enable simultaneous requests.
                        Cesium.RequestScheduler.requestsByServer["tile.googleapis.com:443"] = 18;
                        let googleTileset = new Cesium.Cesium3DTileset({
                            url: "https://tile.googleapis.com/v1/3dtiles/root.json?key=AIzaSyByta5biVaweg4wnMcrvZoSPvWXWjJ5uxQ"
                        })
                    
                        let googlePrimitive = viewer.scene.primitives.add(googleTileset);
                    }
                
                
                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Toggle Google Earth Layer');
                
                // Place the button in Cesium's toolbar
                var cesiumToolbar = document.getElementsByClassName('cesium-viewer-toolbar')[0]
                var homeButton = document.getElementsByClassName('cesium-button cesium-toolbar-button cesium-home-button')[0]
                cesiumToolbar.insertBefore(button, homeButton.nextSibling);

            }


            // --------------------- create_heatmaps_list_container ----------------------------- //
            function create_heatmaps_list_container(viewer) {

                function create_heatmap_container(heatmapURL, heatmapLabel) {

                    var stravaRunHeatmapImageryProvider = new Cesium.UrlTemplateImageryProvider({
                        url: heatmapURL,
                        maximumLevel: 11
                    });

                    var stravaRunHeatmapLayer

                    // Create checkbox
                    let checkbox = document.createElement('input');
                    checkbox.type = 'checkbox';
                    checkbox.checked = false;
                    checkbox.className = "mapView3dCustomCheckBox";
                    checkbox.addEventListener('change', function () {
                        if (viewer.imageryLayers.contains(stravaRunHeatmapLayer)) {
                            viewer.imageryLayers.remove(stravaRunHeatmapLayer)
                        } else {
                            stravaRunHeatmapLayer = viewer.imageryLayers.addImageryProvider(stravaRunHeatmapImageryProvider);
                            stravaRunHeatmapLayer.alpha = 1.0
                        }
                    });

                    // Create label for the checkbox with the track name
                    let label = document.createElement('label');
                    label.textContent = heatmapLabel;
                    label.style.display = 'inline-block';
                    label.style.verticalAlign = 'middle';
                    label.style.color = 'white';

                    // Create container for the checkbox and label
                    let heatmapContainer = document.createElement('div');
                    heatmapContainer.className = 'dataSourceItem';

                    // Add checkbox and label to track list container
                    heatmapContainer.appendChild(checkbox);
                    heatmapContainer.appendChild(label);

                    return heatmapContainer;

                }


                //strava_winter_tiles = 'https://heatmap-external-a.strava.com/tiles/winter/blue/{z}/{x}/{y}.png',
                //strava_run_tiles = 'https://heatmap-external-a.strava.com/tiles/run/hot/{z}/{x}/{y}.png',
                //strava_ride_tiles = 'https://heatmap-external-a.strava.com/tiles/ride/hot/{z}/{x}/{y}.png',
                //strava_water_tiles = 'https://heatmap-external-a.strava.com/tiles/water/hot/{z}/{x}/{y}.png',
                var heatmaps = [
                    {
                        heatmapURL: 'https://strava-heatmaps-test.insoft.net/tiles/winter/blue/{z}/{x}/{y}.png',
                        heatmapLabel: 'Strava Winter Heatmap'
                    },
                    {
                        heatmapURL: 'https://strava-heatmaps-test.insoft.net/tiles/run/hot/{z}/{x}/{y}.png',
                        heatmapLabel: 'Strava Run Heatmap'
                    },
                    {
                        heatmapURL: 'https://strava-heatmaps-test.insoft.net/tiles/ride/hot/{z}/{x}/{y}.png',
                        heatmapLabel: 'Strava Ride Heatmap'
                    },
                    {
                        heatmapURL: 'https://strava-heatmaps-test.insoft.net/tiles/water/hot/{z}/{x}/{y}.png',
                        heatmapLabel: 'Strava Water Heatmap'
                    },

                ]

                var heatmapsListContainer = document.createElement('div');
                heatmapsListContainer.id = 'heatmapsListContainer';
                heatmapsListContainer.classList = 'dataSourceList';

                for (let i = 0; i < heatmaps.length; i++) {
                    let heatmapURL = heatmaps[i].heatmapURL;
                    let heatmapLabel = heatmaps[i].heatmapLabel;
                    let heatmapContainer = create_heatmap_container(heatmapURL, heatmapLabel)

                    heatmapsListContainer.appendChild(heatmapContainer);
                }


                // Create button
                let button = document.createElement('button')
                button.id = 'stravaHeatmapsButton';
                button.classList = 'cesium-button cesium-toolbar-button';

                button.addEventListener('click', function () {
                    heatmapsListContainer.classList.toggle('appear');
                });


                // Close container when I click outside
                window.addEventListener('click', function (event) {
                    const target = event.target;
                    const container = document.getElementById('heatmapsListContainer');
                    const isButtonClicked = target.id === 'stravaHeatmapsButton';
                    const isClickedOutsideContainer = !container.contains(target);
                    if (isClickedOutsideContainer && !isButtonClicked) {

                        container.classList.remove('appear');
                    }
                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Strava Heatmaps')

                // Place the button in Cesium's toolbar
                var cesiumToolbar = document.getElementsByClassName('cesium-viewer-toolbar')[0]
                var homeButton = document.getElementsByClassName('cesium-button cesium-toolbar-button cesium-home-button')[0]
                cesiumToolbar.insertBefore(button, homeButton.nextSibling);
                cesiumToolbar.insertBefore(heatmapsListContainer, button.nextSibling);


            }



            // --------------------- create_avalanche_layer_button ----------------------------- //
            function create_avalanche_layer_button(viewer){           

                // Snøskred layer
                var snoskredImageryProvider = new Cesium.WebMapServiceImageryProvider({
                    url: 'https://nve.geodataonline.no:443/arcgis/services/Bratthet/MapServer/WmsServer',
                    layers: 'Bratthet_snoskred',
                    parameters: {
                        //styles: 'default',
                        //service: 'WMS',
                        //version: '1.3.0',
                        request: 'GetMap',
                        format: 'image/png',
                        crs: 'EPSG:3857',
                        transparent: true
                    }  
                });

                // Event listener
                var snoskredLayer
                let button = document.createElement('button')
                button.id = 'avalancheLayerButton';
                button.classList = 'cesium-button cesium-toolbar-button';

                button.addEventListener('click', function() {
                    button.classList.toggle('on');
                    if (viewer.imageryLayers.contains(snoskredLayer)){
                        viewer.imageryLayers.remove(snoskredLayer)  
                    }else{
                        snoskredLayer = viewer.imageryLayers.addImageryProvider(snoskredImageryProvider);        
                        snoskredLayer.alpha = 0.4
                    }
                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Toggle Avalanche Layer')

                // Place the button in Cesium's toolbar
                var cesiumToolbar = document.getElementsByClassName('cesium-viewer-toolbar')[0]
                var homeButton = document.getElementsByClassName('cesium-button cesium-toolbar-button cesium-home-button')[0]
                cesiumToolbar.insertBefore(button, homeButton.nextSibling);

            }


            // --------------------------- create_lightning_button ----------------------------- //
            function create_lightning_button(viewer){           

                let button = document.createElement('button')
                button.id = 'lightningButton';
                button.classList = 'cesium-button cesium-toolbar-button';

                button.addEventListener('click', function() {
                    button.classList.toggle('on');
                
                    viewer.scene.globe.enableLighting = !viewer.scene.globe.enableLighting;
                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Toggle Lightning')
            
                // Place the button in Cesium's toolbar
                var cesiumToolbar = document.getElementsByClassName('cesium-viewer-toolbar')[0]
                var homeButton = document.getElementsByClassName('cesium-button cesium-toolbar-button cesium-home-button')[0]
                cesiumToolbar.insertBefore(button, homeButton.nextSibling);

            }


            // -------------------------- create_resource_button -------------------------------- //
            function create_resource_button(viewer, resource, buttonId, tooltipText){
           
                //var button =  document.getElementById(buttonId); 
                var button = document.createElement('button');
                button.id = buttonId;
                button.classList = 'cesium-button';
                button.addEventListener('click', function() {
             
                    // Check if NRH Button is pressed
                    if (button.classList.contains('off')){
                        var ticked = true;
                        button.classList.remove('off');
                    }else{
                        var ticked = false;
                        button.classList.add('off');
                    }

                    // Select only the paths datasources
                    let datasources = viewer.dataSources._dataSources 
                    let tracks = [];
                    for (let i = 0; i < datasources.length; i++) {
                        if(datasources[i].entities.values[0].path){
                            tracks.push(datasources[i]);
                        }
                    }

               
                    // Adjust the checkboxes
                    let checkboxList = document.querySelectorAll('#tracksListContainer input[type="checkbox"]');                
                    for (let i = 0; i < checkboxList.length; i++) {
                        if (i > 0){
                            let track = tracks[i-1].entities.values[0];
                            if (track.resource === resource){
                                checkboxList[i].checked = ticked;
                                track.show = ticked;
                           
                            }
                        }else{
                            if (!ticked){
                                checkboxList[i].checked = ticked;
                            }
                        }
                    }   

                });
           
                // Add tooltp
                let tooltip = add_tooltip(button, tooltipText)

                // Create label for the checkbox with the track name
                let label = document.createElement('label');
                label.textContent = tooltipText;
                label.style.display = 'inline-block';
                label.style.verticalAlign = 'middle';
                label.style.color = 'white';

                // Create container for the checkbox and label
                let buttonContainer = document.createElement('div');
                buttonContainer.className = 'resourcesItem';

                // Add checkbox and label to track list container
                buttonContainer.appendChild(button);
                buttonContainer.appendChild(label);



                return buttonContainer;
           
           }


            // -------------------------- create_resources_buttons -------------------------------- //
            function update_resources_filter_list(viewer, resource){
                
                
                let buttonContainer
                let resourcesListContainer = document.getElementById('resourcesListContainer');

                // Create resources buttons
                let resourceButton = document.getElementById('button' + resource);
                if (!resourceButton) {

                    if (resource === 'RKH') {
                        buttonContainer = create_resource_button(viewer, 'RKH', 'buttonRKH', 'Røde Kors Hjelpekorps');
                    }
                    else if (resource === 'NRH') {
                        buttonContainer = create_resource_button(viewer, 'NRH', 'buttonNRH', 'Norske Redningshunder');
                    }
                    else if (resource === 'NLA') {
                        buttonContainer = create_resource_button(viewer, 'NLA', 'buttonNLA', 'Norsk Luftambulanse');
                    }
                    else if (resource === '330') {
                        buttonContainer = create_resource_button(viewer, '330', 'button330', '330 Skvadron');
                    }
                    else {
                        buttonContainer = create_resource_button(viewer, 'Others', 'buttonOthers', 'Other resources');
                    }

                    // Add the button to the list
                    resourcesListContainer.appendChild(buttonContainer);

                }


            }



            // -------------------- create_resources_list_container ------------------------ //
            function create_resources_list_container(viewer){

                // Create resources list container
                var resourcesListContainer = document.createElement('div');
                resourcesListContainer.id = 'resourcesListContainer';
                resourcesListContainer.classList = 'dataSourceList';

                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(resourcesListContainer);


                let datasources = viewer.dataSources._dataSources
                for (let i = 0; i < datasources.length; i++) {
                    if (datasources[i].entities.values[0].path) {
                        let track = datasources[i].entities.values[0]
                        update_resources_filter_list(viewer, track.resource)
                    }
                }


                // Create the open/close button
                let button = document.createElement('button')
                button.id = 'resourcesButton';
                button.type = 'button';
                button.classList = 'cesium-button';
                //button.textContent = 'Ressurser';

                // Add tooltip
                let tooltip = add_tooltip(button, 'Filter by Resource')

                button.addEventListener('click', function() {
                    resourcesListContainer.classList.toggle('appear');
                });

            
                // Close container when I click on the other menu lists only
                window.addEventListener('click', function (event) {
                    const target = event.target;
                    const container = document.getElementById('resourcesListContainer');
                    const isButtonClicked = target.id === 'resourcesButton';
                    const isClickedOutsideContainer = !container.contains(target);
                    if (isClickedOutsideContainer && !isButtonClicked) {
                
                        container.classList.remove('appear');
                    }
                });

                
                cesiumViewerContainer.appendChild(button);
                
                
                


            }


            // ------------------ create_get_my_position_button -------------------------- //
            function create_get_my_position_button(viewer) {

                var myPosition;

                async function fly(position) {

                    if (myPosition) {
                        await viewer.entities.remove(myPosition);
                    }

                    // Get height for the position
                    var terrain = await [Cesium.Cartographic.fromDegrees(position.coords.longitude, position.coords.latitude)]
                    var terrainSample = await Cesium.sampleTerrain(viewer.terrainProvider, 14, terrain);
                    var altitude = await terrainSample[0].height;

                    // Define position
                    myPosition = viewer.entities.add({
                        position: Cesium.Cartesian3.fromDegrees(position.coords.longitude, position.coords.latitude, altitude),
                        label: {
                            text: "Lat: " + position.coords.latitude.toFixed(6) + "\n" + "Lon: " + position.coords.longitude.toFixed(6) + "\n" + "Alt: " + altitude.toFixed(1) + "m" + "\n" + "Acc: " + parseInt(position.coords.accuracy) + "m",
                            scale: 1.0,
                            pixelOffset: new Cesium.Cartesian2(0, -100),
                            font: "bold 15px Helvetica",
                            fillColor: Cesium.Color.WHITE,
                            outlineColor: Cesium.Color.BLACK,
                            outlineWidth: 5,
                            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                            horizontalOrigin: Cesium.HorizontalOrigin.LEFT
                            //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
                        },
                        billboard: {
                            image: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAgAElEQVR4nOydB3hcxbn3Q5KbQL6b3Nzcm5vcoGY1S7K10qq3PWfLOWqWZXXZ2HK3tEU2GEIvpl0CARIglFBCCyVA6ODQbOOCbYx7w73gCkkgJCEJzfPNrLVGtlbaOdpTZua8+zzvY1T2N4x25v+fmTMz79cUxf0tHP+G42vDeZH39b3/W/0CeMADHvCABzzgscwTqjLAAx7wgAc84AGPHmJZ4cADHvCABzzgAc9SnqWFAw94wAMe8IAHPPN5lhYOPOABD3jAAx7wzOdZWjjwgAc84AEPeMCzhmdp4cADHvCABzzgAc8anqWFAw94wAMe8IAHPGt4lhYOPOABD3jAAx7wrOFZWjjwgAc84AEPeMCzhidUZYAHPDvzctrnfcvnC/1XlS+QKvl6nVK13yMp3Y2S0nOWpPoDxyPYLamBoKSELuwfLjXYI1WHumUlOFNWe9tJSNW9TbKvV3FVByo81T0jXTUzflLU3Hg6K/UFHvCAFx9PqMoAD3gi8trb279RqcxJwiYtST7/ZGzYV0hq6FeSEnwKG/YS/O+7shL6UFZDKBxKsC8C/aLve5Hf0RIDeR9KSmAn/vdt/P35+P/lYfz/dDUZPOBBhFrlC2XK8pTTWfn7AQ94wKPkCVUZ4AGPI57XOyVF9vlrcZyDDfYubKgLsAHvxvFZHGatt/nT85TQYTw4WSmrwSfw11fif9vwv1kez4QzePg8gAc8W/GEqgzwgMcojyzVY3MsIsvxsuK/F5v92zj+YqlZm8nz+T+VfP4NuO6PY+aleJDQWKGEfmLV5wE84NmeJ1RlgAc8hnhSdW+WS+2dgQ3/XjwLXhue0fNi1mbylNB7x1cLgnMlX6i8trb32zx8vsADHtc8oSoDPOBZyJPled/EM9sySQ2di2f1z2KD+4AJc+WRpwQ/xYOmFXhAcAvZkKgo3f9h9ecLPOAJxROqMsADngW88K57soNeDT6JDesjLsyVQ56khL6QlOBqPMD6OdkrUdow+d95bC/AAx4zPKEqAzzgmcCT5YmnYyOqx7P8O7Hh7xLBXHnkkX0TkuJ/DkfQVR1IZLW9AA94zPKEqgzwgGcQT6rr+h9sOuOx8T+M42PWzBB4IYQHY1vwv1eSPRdWtxfgAY8LnlCVAR7wdOSFTd/X48czzDew0XzGkxkCL7SB3Jcgq/7RvLY/4AHPcJ5QlQEe8OLklZf3niEpPRMkJfA8Nv5/8WaGdb4e1CrPQBOlaWhG5WQUrJiIzisdjy4vbkdXFLWF4+qiFnR9QVM4flYwDl2H47Ki1nBcUtyG5pZ2onNxnFM6Afnx+ydXTUUt8kxU6/UzV1+aIBcl4cHApXJtbwLr7Q94wDOVJ1RlgAe84fFOI7fsYXN5EMfHLJlXJKp9ATRemopC5WeheYUt6Na8BnR/TjV6aqQXLUhzoXeSy9C2MwvRzjMLqGMHjndJJPSLvu8P9h5SxprkUrQ4tQrNz5DRE1kKuit3DLoG/z+dUzYedVVNQfXebub+fsd5gS9xvCYrPV0eT/P3GGp/wAOeNTyhKgM84Gnglav+/5GV0E/x7HAbCzNXjxJC7Xj2PqfsLPQzZxN6cFQtei1dChvucMxab/PXwlufWIQW4kHCk1k+dJujAV1Q2okmuaYiH/k7MLByIin+j3Dc7VYCpVa1P+ABjxWepYUDD3gm8k4jCW7IkT1yztyqZWsF//dUPFueV9SG7sdG/0a6CxtnkSVmbSZve0IhWppaiX6XraKb8xvDg50GT7ep5j+QF9yI/3tmWdncMzhsz8ADHpg/8IA31IuIOxb5WXi2v9kKs2l2z0AXlnSi+0bXo4VpLurlepHMf6hYnlKBfptTja4qakZTXJORV/GbvhIjqcE/4cHA9UMdKWSlPQMPeGD+wANeDJ6rpvt/sbBfK6mhP5q5zNwmT0eXF7Wih/BMd2VKmVBmbQZvQ2IRejHTjX6e34imVXWFH4+Y8RgmPBBQgp+TTItSTa+LtfYMPODpybO0cOABzygeSUmLjf/+E8v8Bpt/ja8HnV02Ht09ug4tSSln2lx55G1ILAlvOCSPTNrcMwwz/yicNW5fqPWHvaGvi9Q/gAc88n5LCwce8PTmVXkDDizav8PxpdHmQI7bXVvQgl7KcKMtCYXcmiuPvOV4kPXr3Ho0qzLK6oABKzuSEthMTg8UNTeeznP/AB7w+vMsLRx4wNOL51aDpbISegEL9jEjZ4ZdrqnoF/mNaFGaixkztDuPnJK4b3Rd+M4DX3jvgJGnBwLbJF/3NFk+75s89Q/gAS8az9LCgQe8eHmSEsrtM37DloXJ0byb8sehZakVzJuh3XlrEkvQAznVKFQ2AXlODAb030BIckCQFM8k+yPL/QN4wBuKJ1RlgGcfXjgDnxL47ZBL/XGY/1hPd/hyG3IOn1cztDtvZVIp+pWjHk2Qpulq/v1/L3zLYHVvE2v9A3jAo+EJVRngic+T5eCP8Yz/Diy+n+kt5h78dahiInoiSx3ymB6PZmh33utpErqqsBXVe3uMWSlSgkvIYyir+wfwgBcXT6jKAE8YXk1Nz7clJXSh5kx8FGLe5J4ZXuJfmVLOpHkBTz8euWzp0ZzqcJ4EA/aIHCMXTHk8s9N472/AsyFPqMoATxgeFtYm8sxV72VcYgKPZ6vh2+l4MC/g6csjty9eXNLx1fXE+h0d/BQPBG6pqu/+Tx77G/BsyBOqMsATgicp3U4swgv03MDlxf+eX9I56LN9XswLePrxyCmCX+Q3oEbPTJ2PDvqPykrPtIqK0m/z0N+AZ1OeUJUBHve88tqO70tK4CYcn+tl/qqvB/1fQXM4a55I5gU8/XibEwrDJwg6yaZBfRMPvSn5ZuSy2t+AZ2OeUJUBHvc8POtvxMa/Vy/xrfb2oCsLW9A7SaVMmQ3w2OWRS52eyvKiyVVTdVt5wvGZrIRuleXgv7PU34Bnc55QlQEetzypenKSrPif1GvmNcYzC93iGIPWJhUzbTbAY5dH/n0yW6EfCFDsIZCU0F6XGhhrdX8DHvAibxKnMsDjjkeej2Lj7yH52fUw/xo8478pfyxan1jMldkAj23e0yO9aIprSlzm3z8kNfSwLJ/9fd77L/A45wlVGeBxxfN4pqdj81+ox4YrBTOuJc/4k0q4NxvgsckjPydHCEkOiHjM/6vVgOABtxKq4bX/Ak8AnlCVAR43PJfaM0VSAn+J1/w9+P0XF7WFk8OIZDbAY5dH7hK40zHm+KVC8R8dPIZ/9+6Kxunf5an/Ak8QnlCVAR7zvIrqKf+Fjf8RPY5aTamajOanS0yZA/Dsw9uUWIxudDYiRemJ++igpIb2Sarfw3r/BZ5gPKEqAzymeS6l2ysr/v3ximWLeyZ6NFth2hyAZx/e0pRyFKro1OHoYOBL3D9u9Ho7v8Ni/wWeuDxLCwee2LyUlKTTsLBdJCn+z+MxfwX//s35jWhzQhE35gA8+/AezXGjZs+MYZr/SY8Rlkvq9FRW+i/wxOZZWjjwxOZVjJ3yXWz+T8V7w9qsyi60JLWSW3MAnj1465IL0FUlDV9dL6zd/PtuEQz8ya0Exljdf4EnNs/SwoEnNg8LXBY2/y3xmD/ZaHXf6LqwwPJuDsCzB29zkhM9N6oEzXCdNSzz79c/jpHLg3La533Liv4LPPF5lhYOPHF5LjUwEc9i/h6P+ZNELeuSSoQyB+DZg7cl0YmWZDrQLQUKqvFFSUGs5fSAEnrLVR1INLP/As8ePEsLB554vMLC7n+TfYHb4zkaRdLzPpvpZUbMgQe84fC24kHA0sxc9OKoopNXA4ZzdFAJfiDV9Lp40wPgsc2ztHDgicUrq577g3D2vjjMf27ZeLS+b9bPkpgDD3jD4b3bNwhYPDIX3VrgCyelGm7/kJTg5y41FOJFD4DHPs/SwoEnDk+uDqZLSuDd4YpbjTcQftbPspgDD3jD4b2bWICWZTrQm3gQ8GxOMZpKVgPiOQqrBO8mK20s6wHw+OAJVRngWcOTqkMqNv+Phmv+5I51cpMf62K+O7UE7R3tQvvyZbS3wI12jqpC29PL0LbEQib+/4DHLu/dBCdanJmLFuBBwBs4ri2qRd5IH9Fi/idWAwKvuN3Tf8iiHgCPH55QlQGe+TxZDU49nup0eOZ/RVEbIlersijme0aWo/dKfOiQ2oCOtrajDyZMCMf748ejwzgO9cXBtna031uP9joktDOh0HKzAR6bvE2JBejNTEd4ELAQxyO5FajRO/x7A/AgYJvLN3MUS3oAPM55QlUGeIbyJCV0NhaiY8Mxf3Kpz/2japkS811JReHZ/UFPPXq/reOE4fePU83/UN/X5Pvk50caW9CeUVWWmw3w2ORtTHSGHwWQIPsCXsvOR8HKDs3m36+/fehW/DILegA8znlCVQZ4hvHa29u/IamhO4ebCKVdnoEWpg40SUvEPLEwPHM/pDSgDzrHRzV9WvPvH2QQEWs1gDfzAp4+PHJPwJK+jYGL+wYD1xfVxr48aPD+9omkBOut0gPgCcATqjLAM4wny1NOl5TAs8M1/7llE/AsqNhyMd8zsuL4TL+9c0jTH475R+Jw/Ti0K2VgXXk2L+Dpw9ucnB/eExAZBJB41DHEI4HY/e0zPAjoMlsPgCcAT6jKAM8wniwH/x3P/N8Yjvm7cdyUPy6qoJomvni2v6/Ag440NFOZfjzmH4kjY5oGrATwbl7A04e3PiX/pAEAiZdzClCX1KXV/CNxDA8CzuNVX4AH5g88RnmyfPb3yY1kwzF/srT5UE6NZeK7PbUEHZBrqGf7epl/JA6460ytL/D44a0ZMXAQsGikA11Q1qzV/PsNGEK3fm3evK/zpC/As4gnVGWAZwgPz/x/jIVlw3DEiNzl/3KG2xLx3ZFRhvZ56tDRTu3Gr5f5R4IcH7TabIDHJm9VWt6AQQCJnxXVIM9JfU3TpUH3nToIYFVfgGchT6jKAE93ntfbfaasBncMx/zb3DPQstQK08V3x8gKtE8Zgw5j4x+OWett/uH9AA1NTJgN8Njjkd9ZkeE4yfzf7DsqeE+ehGp83cO6NEhSQr+JDAJY1RfgWcwTqjLA05VXoYR+Mlzzn1E5+UQiH7PEl1zKQ4w/XrPW2/wjvF0OyXKzAR6bvG2JTrSsbxAQMf8FffHkqBLU5Jk+rEuDyCDgh72hr7OoL8BjgCdUZYCn48x/zo8kNbhlOOZ/bul4tOWUy32MFN9tKcVor1SDDuIZP6vmTzhkcMKC2QCPTR45Hniq+UcuDXopuxCNl6doHgAcvzDI/2BRc+PpLOkL8BjhCVUZ4On2zF9Sgu8Ox/x/5mwaVPz0Fl+yu353kQcdbG3X3ayN4B1s6zj+iIIBswEem7x3UvIHmH/k0qBXs51oqmuiJvPv138f6BsEWK4vwGOIJ1RlgKfTzD+0Vav5k2N+tznGmiaW5PKeg02thpm1Ubxd6WXMmA3w2OS9leYYYP6RWJiVh4KVnVrN/8QgICUl6TQr9QV4bPIsLRx4bPBKanu/h0VjzXDM/67cMaaI5e4RJeigr94UszaCtyenkimzAR57vK2JTrQkY6D5n9ggmJWLflreotH8I98L3m6VvgCPTZ6lhQOPDV5Z2dwzsDgs0Wr+XjWIHs2pNkUs3yvyoqNtHdyaP/n53jyZKbMBHpu8LUnOqObfP64oGavN/CMbA9XeC8zWF+CxybO0cOCxwZPled+UlMCLWs2fXPDzVJZiuFiSWf/h2kbTzdoI3j4NAwBezQt4+vDWRbkk6NSYV9Kgyfz74hjJ4smrXgFPP56lhQOPCd5pkhq8n1XzJ9n5jrZ3CmH+JEgOAhbNBnhs8lamO2IOAq4trtd8Y6CkhL6Q1FAzh3oFPB15lhYOPOt5LiX0i+GY/++zfMaKZWIhOiDXWWrWRvAGSw7EgtkAjz3eNvyzJZlDDwLeDD8OGKP9xkAl9ImrOlDBk14BT1+epYUDz1oeFoheFs1/d0YZOtLYYrlZ6807Mq6VabMBHpu8DcmDPwrof2/AvBODAA03BirBP7uUQDYPegU8/XmWFg4863gkfziOL7SYvwd/3+hlf7Lk/35Hp+VmbQTvvYrBN0uyYjbAY5P3dpR8AdEuDTq+EqDtxkBJCe0sq577A5b1CnjG8ISqDPDoXpXe2TnY/P+i9ajfA6NrjRNL/PsHqmqYMWsjeLszyrkwG+Cxx9uOf39p5tDmH7k34KKyJk0DgOODgMDrHs+EM1jUK+AZxxOqMsCL/Qpn9lMC+7Xe8HeHo8EwcduVXIQO1zQyZdZ68w76zLknAXji8jak5Mc0/3A64SwH6q1opx8A9PV9PAi4gzW9Ap7JPKEqA7yTXn1n/VdpNf9f5DcaJm7kiN+Rsc1MmbXuvM7xaHequYmRgCcmb3l63pDmH4kFWXlomussavOPaIGk+gOs6BXwwPyBpyNPUoIPazX/awpbjDP/jHJ0tKWdLbM2gLevwMOl2QCPPd7GRCdakDm0+Ufitex8NEGeTG3+fXrwmVvxyyzoFfDA/IGnE8+lBEPDyeq3PaHQEHHbk12J3m/vYM6s9eYdqIy+8Y8HswEem7yVqfkxzT8S83MKUCtJJUxn/scfBaihP3o8wWQr9Qp4YP7A04knKz1lsi/wqRbzn+KagjYnGpPSd29OFTb/TubMWnfzr6oOZyzk2WyAxx5vC47FmY6Y5h+J50YVozpfD5X599OAVTnt875lhV4BD8wfeDrxvN7eH0lK4KAW82+RZ6I1yaXGmH+uK/xMnDWz1pP3flsH2ueQhDAb4LHJWz/E3QDR4qG8qvAdHhrv/bjJbL0Cnsk8oSoDvJNesnweueN/sRbzr/X60aLUKkPEjZhif+Nkwaz15JFVDXLWn5xqEMlsgMcej8TyjNjXBPePGwqrNV36heOY2xccx6v+AY+CJ1RlgHcST1L8N2sxf5LZ74VMYzas7R0t5sz/aGs7OuipDyf5Gcz4eTcb4LHJ25REvwoQOTp4bnmzpuuCJTX4p0plThKP+gc8Cp5QlQHeCZ6k9tTJiv9LLZ397tx6Q8RtT07lidv9eDd/Mss/pDag/UVetDu9jFlzAJ49eDTJgvrfG/DaSAeaSo4HarguWFKCKwsLu/+tv76wrn/Ao+QJVRnghXk+39QfY/M/pMX8LyrpMMb8syr4N3/8/39AGRPevxBtUx+r5gA88XlbEp3U5h+Jl7MLUKNnBv1FQcc3Dt7Ai/4BTwNPqMoAL8zDpv+UFvOf6Joadcd/vOK2K600vETOq/m/19CEdhe60c4hlvZZNgfg2YO3Mn1gnoBYNwY+lltxfFMg/QDgS3I/AA/6BzwNPKEqA7x/k309fi3mX+/tQctTBt5RH7f5JxWho+NauTP/g52daB+e7e/IrhTCHIAnPm9r0sBVgFjXBZO4vqhWywAAh3+P2z3xByzrH/CGx7O0cODpw/N4ZmVh4/8rrfmT7H7PZnr1N/+EQnS4dhxX5n+IGL+vHm1PKxXKHIBnD17/VQAa84/8nr+yk9L8I6cH/Heyqn/AGx7P0sKBpw+vrq76DNxB39GSD/zmKHf86yFGB9x13Jj/UWL8ci3anlrCjJgDD3haeVv79gLQmn8kXsl2onGemZTmH45jLsVfzZr+AW94PEsLB55+PDwyv1CL+c+onBxOMaq3GO1zurkx/4Nqw1czfobEHHjAGw5vBWWioFNj0P0Ag1waJCnBfRWN07/Lkv4Bb3g8SwsHnj48l2/6SNw5P6E1f3It6MoR5bqL0Z7M8hNn/Vk2/6NNrWhProtpMQce8LTyyO2AWs0/EtcV1VGZ/wl9UYJ3s6J/wBs+z9LCgRc/r6Ki9Nt49v+6lnO9j+ZU6y5Gu5OL0NHmNrbNHw9O9pf6wkf5WBdz4AFvOLzFGQ7N5k9iUZYDTXZNojP/43HMpfZ6rdY/4MXHs7Rw4MXPk5WeGVrM/5LiDkPE6FD1WKbN/8jYZrQno4wrMQce8LTyVifnazb//kmDFKVHw3XBwe21tb3ftlL/gBcfz9LCgRcfr1KZfKak+P9Ea/5t7hloU1KR7mK0v9jLrPm/P/54Vj5yMoE3MQce8LTytp7pREsytZt/ZAPh9UXVmlKGS0roQlH01I48oSpjN56kBB6nNX83jpcz3LqLEZlVk5v+WDR/8qx/b1YFt2IOPOANh7cmNfrFQDQ3Br6B4/hVwZS5ApTg313VgUQR9NSOPKEqYyee2zfLR2v+JK4oatNdjHbh9x1paGbS/Mk9BLuSi7kXc+ABTytvW4zrgWNdGvRsTjGq9nVryRXwFO96CjwWCgceFa+gtenbuNOtpjX/cZ5ZaGOi/mZIUt+yaP4HXDVoZ4IYYg484A2Ht4IiSdBQ9wbcWKhSTy7CK4xKqIZXPQUeC4UDj5onK4GpWjrnE1mK7mIUXvrv7GTL/PHv7S/0WC6+wAOe1byNybFTBQ91aRA5FTBR7qLWGEkJ7ZTliafzqKfAs7pw4FHzyst7z5CV0Hu0HfO80vGGiNHhunFMmf/7re3hzIMsiC/wgGc1j3x/6RCbAWluDHw8t5zM7OkGAeELgnou4E1PgWd14cDTxMOd7Upa8yeJflYnleouRvsK3UyZ/9GW9vCKBCviCzzgscB7Z5DNgFquC76grJnK/I8PAPx/crun/ZAnPbU9T6jKCM7zervPJLtuaQcAd+fW6y5GO0cUo0Nt7eyYf1Mr2p1awpz4Ag94VvM2DzNLYP94NduJGryzYpp/5Nig5PPfwIueAu/4G8SpjOA8bP4P0pp/pzQdC4X+N97t89SxY/7NbWj3CDB/4AFvsFiWOXzzj8StBT4q8+87OvhJhS/wEx70FHjH3yROZQTmVflCmZIS+oJ2APD0SI/uYrQjszycNpcJ829pR7vTYdkfeMAbKiJ3AgzX/CPv7ZK6aMw/HC41dA/regq8r94oTmUE5uFO9xCt+fdUTDREjPbXNDJh/u+3dcAzf+ABjyJImuB4zD8SJGOgm8L8+04EfFHpnZ3Dsp4C76s3i1MZQXkez+w0SQl+TmP+HtwZF6RW6i5GO0e7mDB/ktBnT3YlF+ILPOCxwFucGZ/5RyJY2UmbKIjE06zqKfBOBohTGUF5khq8n/YozuVFrfqLUWIBOjC22XrzHz8B7ct1cSW+wAOe1byVqXlxmz+Jp0eVIO9Jxj/kdcHHJN9sJ4t6CrxTIJYVDryYPJfaOwJ3ps9ozF/x9aC3k0t1F6PdTrf15o/jvTKVO/EFHvCs5q1Pyo/b/COPEc4tb6ZPFKSGHmNNT4Gnw4v1yojEIxtqaM/hXutsMkSMDjS2WG7+h9QGLsUXeMCzmrcVx6JMR9zmTwYRL+QUINXXE9P8I3sBJGVOBkt6Crw4X6xXRiRepTInCXeyT2nMX+0/+9dRPHblyZab/xE8ANnVl8aYN/EFHvBY4K1M054hcLDTA5eXNFAnCpKV0K9Z0VPgxflivTKi8SQ1eBeN+ZPluKsLmg0RjwNjmiw1f3K//56RkNIXeMCLh7d+ROzcALSXBr2S7UQ1ZBWAYgAgKcF/VSihn7Cgp8AbyLO0cOANzvN65/yIdB4a81eUHrSSzP51Fo9dDsla88exv8THvfgCD3hW896NM0XwqXsIrigZS7cCcDxuslpPgRedZ2nhwBucJ6vBy2jMn8SVhS2GiAdJ+GOl+R+ubRRCfIEHPBZ4y4ZIDqTF/EnMzynAEw8/7SrA33y+qT8WSZ9F4VlaOPCiv2R53jdxpzlAY/4+PPtfkVymu3jsziy31Pzf7+hEu9P0T2QEPODZlbeKYh+AlkuDLiprojqa3Jco6BJR9FkknqWFAy/6C8/+22jMn8Q8PPs3QjwOeuotM//w0n+xVyjxBR7wrOZtSBl6H4DWGwNfHFWEJyABqj1KkhLYV1dXfYYI+iwST6jKiMKTldBCGvMnt/6tSCnXXTzIjnsyA7fK/I+MaUI7EvRPZAQ84NmZRy700sv8I3FueSvVY0oSbqV7nAj6LBJPqMqIwPPUBEfRdCby9TllnYaIx3slPsvMP7zrP6vCcrEEHvBE5C3NdOhm/iSeGVWCjZ1OryQl+JLZego8jTyhKsMhb8DRvyHu3n4pw22IeBwZ12qN+eM44KljRiyBBzzReG+nO3Qz/0h0V02g0iscX5KbTc3UU+CB+XPDq2ic/l08Sv6YpjNNkKZpFhEa8diTU2mZ+R9t60DbRhQzI5bAA55ovLX97gPQw/xJ/CZPim3+JyY1wet51WeheUJVhlOe7AvNphpJ45/fO7rOEPE4KNdZYv7kfXsqVKbEEnjAE423Kcmpq/mTWJTlQE2eaXRZApXgB7W1vd/mUZ+F5QlVGY55khJaR2P+tT4/2pxYrLt47MLff7+13RLzP9SOZ//JxUyJJfCAJxpvO36vnuYfGUxcW1RLmyUQVVX3dvKoz0LyhKoMxzypujeLdhntmsIWQ8SDpNq1wvzJ+/eWK8yJJfCAJyLvzUyHruZP3v9ytjN8IylNlkBZDTzPmz4LyxOqMhzz8Oz/Ghrzd+NYllphiHgc8o2xxPwPhmf/RUyKJfCAJxpvWVqeruYfYc2paKHKEojjM58v9F886bOwPKEqwy/vNEkJ7KJ5huavmGSMeCQWDnn23yjzJ5y9VdXMiiWPvNXJpejFTDd6YHQt+vXoMeg2RwO6vqAJXVXYiq4oakPXFTSjm/PHodvzGtB9o+vQ77JVtDC1Cm1KKOKyvsDTxluZmqe7+ZN42FGhJUugnyN9FpcnVGU45clKTxnVBhocD46qMUQ89jokS8z/YGcn2p6qfyIju/CWpFSge3GbuKi4HU1xTQ7vD9GQpOWkDacexY9a3TNQsOIsdIOzET2PBxFbEoqYqi/w4uetSc7X3fwjvHb3VLr8AGpoKS/6LDRPqMpwypMU/+005q/g722MsflvuOIx2NW/Rpo/iX2+eqbFkjXeZmzIv81W0IXY8JuxWdM9c41t/oO1P3LVa+BRCe0AACAASURBVHdlF/pl/li0NLWS+78f8ArQhiSnIeZPfn5VyRjatneM3AnAgz4LzROqMhzy6upqTscDgKM0u2fPKx1vmHgcjbL732jzJ7Eju5JpsWSF90a6C11V2ILqvN3Uu63jNf9o0eGehm4oHIMWZhahd9Ly0OrUPPQOjjUj8tHaFBx4dkkMZlOiE21NZOfvB7yveNvOHPxK4HjMn8Rz5GZA+vZ3Mev6LDxPqMpwyHMps+ppxfeJLMUQ8dgzssIS8z/Q2MK8WFrJI8vvd+fWo7bwTF+7Wett/v2DrAz0VrSjJ3LLhzSHZZkO9HYaGSDkoY14cEDy0tP8DVj8PETiLYlyJXC85h+JSXIXVfuTlMAm1vXZLjxLC7czD3eCh2jEt87Xg7YmFBoiHu+Vq6abP/l6f4mXC7E0m0fueLgrdwwa55mli1nrbf6nxlTXBPRQbiX10bKlOFam56F1I/LRVjwgYP3zEJG3PJ1+AKD13oAbi6qp25/LN30ky/psB56lhduZV9TceDruBO/TiO9lRW2GiceR+ibTzf9oZyfalUJ/mZFI4jtYbMcDvDsdY1C9t8cwszaSNx0PBJ4YXap5g9myDEf4UcKWJCdTn4fIvLfT6AYAw7k0aH5OAfKqg7SnU9qfpPTMZVWf7cCztHC781xqTyWt+L6QOXC2rId47EouRh+MN9f8wzf/VY/lRizN4L2eJqEprimmmbVRPC+OC8rGodezhs49P5jZLCaPDPBggOwhEOnzZY23ZkTszyeeGwNn9U8QNGT787/Oqj7bgWdp4XbnSUrgShrxbfR0h6/wNEI89vbd/mem+ZOf73Nqy2Qokvj2j/VJJejSovaBG6c4NP/+vEbvDHRPvhzXMjNZpt6YlM/158sqb33K0AOAeK8LvqmwmrK9BD4lSdBY1Gc78Cwt3O48PABYQSO2lxW3GyYeByqrTTd/8i9ZeeBFLI3ivYZn/a3yDMvN2kjenIo29EZWXlxmszzDEd5AyNvnyzJvc9LgAwA9cgW8mFP41aA2Rntx+0KtLOqzHXiWFm5nXlV9939KSugLGsF9Iks1TDwO1TWaav4ktCz/syCWevPIz8gtfFGfk+pg1t7a2Wji1CvRRZfdhW65/Ql0173PoIcfnY+eemYBevaFN9Gjj7+K7n/oJfTre59F1/38YRSYcyNqaD7fsMHEBHkKenZUSdxm8xYeCGxKHrhpkLXPlwfelkSnYeYfCfK507QXrIMPsKbPduFZWridebjhj6cRXA/uKBsSSwwRj50JhehwR6ep5k9ifxHd7n9WxFJP3sakYtRbPlHXmfq4tgvRldf+Bj3/4lK0d99h9NnnXyDyOnbsGPrss88GBPl+tNdHf/kbenvVlvDAoKf358hTM1u3wUmNrwf92unRxWxWpjvCxwlZ/Hx54b0bZQCgd5bAK8ilQDTtRQl+8LV5877Okj7bhSdUZXjiSUrwQZoBwMyKLsPEY2dWhenmT2J3aglXYqkXb01yKepyDXJVqkZzbWq/CP3qzqfQtu37oxq6VvOP9vrb3/6B5r+yAp3901uQ58T/4/BXJtxKCN1UWKOP2WTmojWpeSf+3ix8vjzxdpzpNNT8yfseya2gbi+e6kAhS/psF55QleGId5qshA7TiOateWMNE489JV7Tzf9IYwt3YqkHb3lKOWqP9rxfo/nPveA29NaKjejzvll+tJce5n8q7+DB99G99z+PGprPi3sPwTw8M9TLbN7KyEWbkpyWf7488iKXARlh/uT9b+AY451J116U0DkM6bN9eUJVhlGe5JvtpBXLN9JchonHPmWMqeZP4oBUy6VYxsMjmfYayRW+wzR/d3UvuvjyX6MtW/dQmbXe5t+f85eP/4oeefwVNK79wmGZf6Ru55U1hw1CD7NZhGPViDy0VZD2YhaP7KkwyvwjrHPKm6kGi5ISeJYVfbYtT6jKMMyTlNDZNGI51jsLbTVQPA40Nptq/iTIsUMexXK4vOUpFWisZ/jmPyt4A9q6bd+wzFpv8+/P++e/PkX3PfAiUurP1mz+kbpeWNqoq9ksTXegzQl0Vw2z2l7M5JFjlkaaP4lbCnx0K0VK8M+n7gMQRe+54AlVGcZ5khp6jEYsScY3o8RjW2IhOtTZaar5f0CO/yVFTy/LulgOh7c2uRR1ytOHZf71TT9FTz2zCH355ZfMmX//18FDH6DzL7lDs/lH6nttcZ1uZkO+XpqZG/V6YR7ai9m8t9LyDDV/8vULo4qoB4iemuAoFvTZdjyhKsMBDzf23TRi+UBOtWHisT2z3Fzzx3F0XCu3Yql5t39iMZo0zA1/c879JfrjHz/S3ayN5D3/0lKkjjlHc33JWfFbChRdzCZiXuTZNtkXwFN7sYK3PD3PUPOP8Jo8g+x9OfUxgBoIsqDPtuIJVRkOeOWq/39oZ0qLR1QYJh778mVTzZ/EQU89t2KphUfu9A+WT9Jshp7qXnTfAy+gL76gm/WzYv6R167dB9GkaVdrfszhUYPoIUeVLmbTP2LdGcBKe7GKt7xvBcBI8ydxTkUb3QBACTxutT7bjidUZTjgSUqokcb8673dxzc1GSQe5AZAM82fxP5CD7diqYX3y7xGzeZfM3YuWvH2ZtPM2ijeP/7xL3ThZXdRm3///S4v5wydp344G9aGGgSw0l6s4q1IzTPc/EncUqBS7hEJHLJan23HE6oyHPAkJXgdjTmEyiYYKh7kNj4zzZ/E7oxybsWSlvdyhjt8eZMW8ye38G3astt0szaKR/Yt3HDzI5rvDZjmmojezNLP/COxOUo+AVbai5W8t0fkG27+JMgtkLR7RLzeKSki6T3zPKEqwwEPN/IFNOZwc36DoeJxtKnVVPMPbwBM4FcsaXhk0984zyxN5t824VK0b/8Ry8zaKN6nn36KfnXXU9TmH4lriut1Nf/InoB3E9lrL1bzaDIC6jUYa/BG6RdR+odbmTVOJL1nnidUZRjntbe3f0NSQn+jMYfnMz2Gisf7bR3mmT/ZANh3ARCvYknDO7+kU5P5N7ZdKKT59+fcevsT1OYf2Q/wRG65buYfCXJhEMmoyVJ7sZq3dhgDgOF+Hv7KKH0jSv+QFP8Voug9FzyhKsM4r8obcNCYgwf/S3aRGykeNAauZ5bAg74xXItlrPe+kOnV9sy/Ya5Qy/6D8f716afoymvuo3sG3BddUlfYUPS+pGZlWh4z7YUFntYBQDyfx5UlDVT9Q1ICvxdF77ngCVUZxnmSEuyiMYcJ0jTDxeODzqFNXO8Uwe+VK1yL5VDxbkIR6pBmUJs/SbKz6p2tzJm1UTySnIjkE9AyCPhlgc+QS2rWpORb3l5Y4a0bMXSaZj0fw5BEUDT9Q/IFd1qlz3bmWVq4XXiSErqGZnf0JcXthovH0XEtppk/ed/OPJlrsRwqbslvpDZ/8vOHHpnPrFkbxfvwo7+ils5LKHeDB1E9ORWQ7dT9nPrCzFy0KdEpVPsbLm9dCt0KgB4rMc/3vxBoqP6hBL+saJz+XSv02a48Swu3E09Sgk/RHI26w9FguHgcVqOfAjDC/Mn7t6UUcy2Wg8X6pBJU7fNTmz+ZCdPe7meVWRvFW7d+x8AUw0MsC19a2mDIOXVyAY4o7S8e3jqKRwB6PYYhv1/r64nZP/raQJUV+mxHnqWF242HG/tGmqNRz4z0Gi4e+4u9ppn/gbHN3IvlYHFjfhO1+ZNNf3/+88dcmLVRPHLREY35k6j2dYdXAYw4qrYpeeDRQB7bXzy8WI8A9N6DMVk6K7b543CpoZAV+mxHnqWF24n3w97Q1yUl+E+ac9EkgYzR4rELz8g/6GfsRpk/4eytquZeLKPFxqRiVO/toTJ/EvNfWcGVWRvB++yzzwfeFjjE3+/KkjG6mz/5+bKMXE2fNYvtL17eUAMAI7IEXlA2Lqb5k5DU4C/N1me78iwt3E48SZmVQdP4ffhn5LiSGeJxuO8yICPN/1BHJ9o+ooR7sYwWt+aNpTb/0Dk3U5stK2ZtFO+dNe9S75mo83Wj17KN2a2+PoVuFYDV9hcvb7BTAEalCL6pUImpf8fbQ+gFs/XZrjxLC7cTT1L8Y2kaf6wTAHqKx56MMnS000Dzx7FPrhVCLE+NbWcWokZvN5X5k+fe5J58Hs3aKN7lV99LPXi6oahWd/MnsTTTEfNzZ7X96cFbG2UFwCjzJ5z78lyxzZ+sACihTbzrPS88Swu3E09W/OfRNP65ZeNNFY+9Uo1h5n+guQ1tTy4SQixPjd9n+eg2NOG45mcPmGquPPD2v3cUeU4MAIb++02Qp+hu/jSrACy3Pz14a1LzTDN/Es+QkwA0l0IpoU+wfJ7Gs97zwhOqMizzJMV/N03j/7mzyVTx2JZYiPbXNepu/gc7x6MdOZXCiOWpMbe0k8q83NW9aPeeQ6aaKy+8y6+6m+qZMIknR5fpbv4kyA2BPLY/PXir+w0AjDb/cGTlIp/iH9r8IxsBa7r/l2e954UnVGVY5uEBwKs016E+lFNjunhsG1GMDja26Gj+nWiX0y2UWPaPDYnFSCFCRmFel8672xJz5YG3bfte5FaDMc2fxGWljbqbfyQ2Jzm5an968Vb1DQDMMP8Ir8UznWoA4FZ7K3nWe255QlWGIZ6kBNfRNPw/ZMiWiMfOpCJ0uG5c/Obf3oF2jq6yXNyM5N0zupZ65rp+405LzJUX3tk//SXVsjBJF7woy2HIM+u30/K4an968Vbheptp/uTnM1xnUQ0AyK2pPOs9lzyhKsMYT1JDR2ga/vIU61Lm7kooRPtLfej99s7hbfhTG9D29DImxM1IXm/ZBCrz75x0xZBGyZtZG8F76Q/LYj8T7ovf5Zbrbv6R2JHg5Kb96cVbmeYw1fxJnF/WQjkACF3Bs95zxxOqMqzx5s37Om7QX9A0/C19SYCsFI/dI0rQQVctOtraHtP8yXI/Mf6do11MiZtRvC2JBajW1021bP3Awy8LZdZG8P7xj3+h2sZzqUzhZ0V1hj2z3kByBHDQ/vTkLUt3mGr+JK4rqqf6rHG/uoNbveeNJ1RlGOR5vXN+RNPoa71+tsQD/97e0VXoQIWKDvnGhK8PPlzbiA5hwyeX+5Dn/Ceu+GVM3Izi/SFNojJ/EocO/VEoszaKd+3PHqQyhZ7KCYY9s16OzZCH9qcn780Mh6nmT+K2AoXG/HH4n+JV77niCVUZRnme6t48GoHrkKdzIx525d3iaKAyf3LbHQvmygPv9QXvUA0ASM6FBSONW7bemsh++9OTtyjTXPMn8Zs8icL8wxtDF/Gq91zxhKoMozyXGqimEbgZFZO4EQ+78kLlZ1E9s7751seZMFceeCQ/AjkuSTMzfNhRYdiy9boke2UJXJBprvmTeDy3gsb8yQrAJl71niueUJVhlCf5/JNpxO2c0k5uxMOuvGZ5BtVsddHitUyYKy+8KTOvoZoZ/rLAZ9iy9dup9skSuAWH2eZP4oWcYgrzDyBJCRzhVe+54glVGUZ5sho8n0bc5hW2cCEeduVtTihCHsod6x9++FdmzJUH3i9u+x3VzPDykkbDlq3fSncw3f705G1OMCbLYqz3vpGVH9P8+wYAn6ekJA24DZAHveeKJ1RlGOXhxn0DjbjdnN/AhXjYlbcwtYrK/Me2nM+UufLAe+a5N6lmhsGKTkNnrlrbDa/teUuS03Tzj4RKPsshzP/E9+Szv8+j3nPFE6oyjPIkNXgbjbjdmVvHhXjYlfdYtko1ACCZ/1gyVx54AzIEDmIOHfJUQ2euWxOdzLY/PXlbErUPAPQ6fTHOOyO2+ZOfVwfTedR7rnhCVYZRnksN3UMjbveOquFCPOzKu80xlmoAcMNNjzBlrjzw3v/gw5j9g3yt4H+NnLlusEmK4E1JxqRYpolO91SqRFpV3oCDR73nkWdp4aLzJDX0MI24PZRTzYV42JVHEjXRDAAeemQ+U+bKA4/8rlI3h2pmuDBrYBpbvcyLJMhhtf3pySMDHSvMn8QEuSum+ZOQfIFiHvWeN56lhduBJ6vBJ2meeT2erXIhHnblXV1EcY0p/hyf/P0CpsyVF97Y1guoZoavZBcYZl5vpw29EVCU9rx2BN0AwIhLlyZJk2Kaf19fquJR73niWVq4XXiyGnieZmbzVJbChXjYlXdJcTvVUbWX5i9lzlx54HVMvJxqZvj8qCLDzOutjMEHAFa3Pz15q1NjDwCMShQ0lSQEosil4VJ7vTzqPU88Swu3C09SQq/SzGyeG+mxVDy2JRSi7aklaEd2JdqZJ6OdOZVoV3oZ2plYyJW4GcU7t3Q81VG1NxauYs5ceeBNnXUN1czwqdFlhpnXksxcZtufnjySCdAK8yecmVXjY5p/+BGA2lvHo97zxLO0cLvwJCX4Js3M5uUMt/nigU1/n9ON9itj0MG2jhOZ/UiiH5Lw50Tin9pGtL/Eh3alFDMvbkbx5pQNksr0lMHd4qVrmTNXHnjdoeupZoaPj64w1Lx2JLDZ/vTkrUwffABgdIrgnsqOmOYfHgBU9zbxqPc88Swt3C48SQm8TTOzeS1dMlU89uXL6EhT60kpfU81/wFZADs60QGSCCi5iFlxM4p3fkkn1VG1195YyZy58sDrmn4V1czw6VGDrwDoYV7v9jsKyFL705NHHnVYYf4kQhVtMc0/fAqgureTR73niWdp4Xbh4QHAepqZzcI0lyniQWbxh+vHnUjpS2v+Jw0EmtvQnpEVTIqbUbzLTt0DMMhjnRdfXsacufLAax1/MdXM8KWcYkPNa2uSk8n2pxeP/HyJReZPvj67opXqNE2VGprCo97zxBOqMqzyvhoADC1uQw0A9BKP3Rnl6Cg273jMv/9qwF6HxJS4Gcm7tqAlpvmHTwE8vYA5c+WBVzfuXKqZ4evZAzew6WleW5LymWx/evHejXIJkFnmT75/DlkBoBgASEqwi0e954knVGVY5R1/BBB7ZjPYIwA9Z/5HW/Qx/xODAPyePaOqmBE3I3k35Y+Laf7k5/c98AJz5so675N//BN5aDIC4ngzy1jz2tSXFZC19qcXb3NyvmXmT34+pyLGaZoTEWzjUe+55glVGUZ4suJfSjOzmZ85cBOgbuKRWIgONzTrav6RAcCh1na0Pa2UCXEzkndX7hiqc+rzrrmPKXPlgbd332EqU6j19RhuXuG0wAy2P7146/pdAmS2+ZPopR0AVIcaeNR7bnlCVYYhnqQEXqdp8C9keg0TjwMVqiHmH+Htr21kQtyM5P1+pIfqnPr0nuuYMlceeEuWracyhSlVkw03r5MGAAy1P714kSOAVpg/iWBllM200cIXUnjUey55QlWGMZ6khl6iafDPjPQaIh7hpf+2DsPMPxI7R1dZLm5G8pamlFOdU69uOAd9GcMkeTZrI3iPPv4qlSmcX9phuHmtjwwAGGt/evGWZzgsM38SPVVD3KcRiXDf6nbzqPfc8YSqDIM83JifoRG3J/puAtRbPN6rVA03f/L14bpxloubkbwtiQVIUfxUR9X27T/CjLnywLvq/+6nGgDcUNBguHlt6NsDwFr704WXcPwaZavMn8Q010QK88fh6y7nUe+54glVGUZ5khp6jEbcHsqpMUQ8DjS2GG7+YR6O3SNKxBHLKLwJ0jSqo2rPvbCEGXNlnUf+u7nzYqoBwL0Or+HmtREPAFhtf/HySBpgK82fxERpcmzzDw+ypzt51HuueEJVhlEebtC304jb7Y4xuovHjowyc8y/73f2F3k1/f+xLJbReOeXtFMdVbvi6oEbAUUwayN4e/YeonsmjP/uz+SUGm5e7yay2/7i5a1JybfU/Em0k3TAMc0fhzojm0e954onVGUY5clq8CoacfuZc5zu4rGrwG2a+ZM46KkXRiyj8e4fXUNlVo1tF560D0AUszaC9/tnF1GZf5N7pinmdepVwCy1v3h5K9PyLDV/EuO8M2KbPw6vd2YCj3rPFU+oyjDKk32h2TTPvC4tbtNdPPaU+UwzfxIkZ4AoYhmNt2JEBd1sFcf6DTssN1ceeHPOu4XqmfBPS9oMN6/BkgGx0v7i5S3JcFhq/iRUso8mhvlLSvCLH/aGvs6j3nPFE6oyjPJw455A88zr7LLxuovHXqnGNPMncaSxRRixHIzXIs+kGgD8/OZHLDdX1nlHj/556AuA+vWPOxyK4eY1VDpgVtrfcHlbEwvQgkxrzf+NrLyY5t/3vcO86j1XPKEqwyjPpQaqaZ55zajs0l089rlqTDP/8ApAQ7MQYjkU79IiuotM6hrPRX/929+FMWsjeA8/+grlhrAAeiGn2HDzIkvkrLe/4fI29G0AtMr8STw/qojG/PHPg2t51XuueEJVhlGe5JvtpHnm1S5P01089pf6TDP/8ABAHSuEWA7Fe3qkl+qZNYn5r7wljFnrzSN7JCZNu4rK/KdUdZliXqtT6QYAPLbnd0bkW2r+JB7LraAw/xCS1OArvOo9jzxLCxed56rp/l+aZS+f4kfbEwp1FQ+S8tcs8w9vApTrhBDLoXjkM2r0dlPNXCfPuAr969NPuTdrI3iLFq+lMn8St+TXmGJe60bEHgBY3f6Gy1uRHj0FsFnmT+JerEc012lLSvBBXvWeN56lhduEd5qkhv5JM/J9O6VMV/HYNaI4fD7fDPMnsS9PFkIsY/FOygwYw7zeXLKGe7M2gjcreAPdbnAcr2YNzGBnhHlt7ksFzHr708rbfmb0FMBmmj+JGwurY5r/8Qheb6I+25ZnaeF24klKaBvNyPfljIEJgeIVjyNjmkwxfzLQ2JVcxL1Y0vBI6mYa8yJfzwpePyyDZcms9ea9tWIj9d+vt3y8aTPX7Ql8tD+tvC1J2gdQRty4eHHpWArzDw8A5pqpz3blWVq4nXi4sc+nGfk+OKpWd/F4ryT2PgA9EgUdUhuEEEtaxkRpCuWGphB6bcEqbs1ab95nn3+Bpsy8hnY3OLrf4THFvJYNcQSQxfanhbd2RL7hfz8aXqCyncL8SfS2m6nPduVZWrideLjB30Uz8r0xv0l/8UgsREdb2g01/w/GT0C7M8qFEEvaeGC0j8r8STR1XIT+9rd/cGfWRvAGJP4Z4u83Xp6GFmVpe3Y9XPN6e5ATAKy2Py08Lc//jcy1MF7uojB/sgcglMuz3vPCs7RwO/FkxX8hzcj3/JJOQ8RjX4HbOPMnm//cdcKIJW2QvOpt5FpTqmeaIXTbHU9xZ9Z6897/4ENU23gu9crJPXk+02au6/HnyVP7o+WR5/8smD+JWl93TPPHP/uyrGzuGTzrPS88Swu3E8/t6+mkGfmeJU03TDwO+sYYYv5HxrWiXUlFQoilltiY7ES3FPgon2mGkKdmNlq/cSc3Zq03jxz7O+/CX1Gbf4c8Hb2ZZd6y9dZEJ1ftj5ZH2ikL5v9StjO2+R+f/e/lXe954QlVGZZ5sjorl6bxe/DPt0Y5CqiLeCQWhi/q0dP832/rQLvTSoURSy28jdgwXh/pQE2eaVTLmiRaJ1yKPvrL35g3ayN4Dz/6B2rzJ/Erp2qa+S8dmctd+6PlrUrLs9z8SdyX54rZP8IDADX0B971nheeUJVhmVdXV3M6bvyfxGr8JN5IdxkmHmSX/kG1QRfzP9rcFn7uL5JYauFtTXCGr1a9J0+iMv9IzD3/VtslCiIrH97a2dTm3yVNoX72r4d5rer3/J+X9kfDI99bmjn039EM8ydf/6yILpGWrAZv4V3vueUJVRnGeJIafIemA9w/us5Y8cCMva4adKhz+OZPkv7sSikWSiyHw1uc4QiLW09lB6W4HY9f3/sss2atN+/Q4T+i5s6Lqc3fo4TQ73IrTF223picz2X7i8Xbkjj08r9Z5k++P7e8la5/KMGACHrPHU+oyjDIk5TgfTQd4OqiFlPEY0dGGdqvjNFk/iTZD7ldkAVxY4G3ItURFrcXRhUh5dQsZzHi8SdfZ86s9eaRxx0nrvulMH8SF5c2m2r+izOPn//nsf3F4q0eMfjyv5nmT35+ljyZql9I1QGPCHrPFU+oyjDKi5kWuC9mVnSZKh6708vQe6U+dLh+HHq/tePkZ/ztnejI2GZ0oKoG7cmqQDv79iewIG4s8MjO8YgA/l9xPf0AAJueG//7h1eXM2PWevM++cc/v7rtj9L8x3q60avZsTet6WleK9Md3La/WLxlGdGX/802/4UjHUgln3nsvnFMkrr/WwS954YnVGUY5rnUoERjDqrPjzYlFFkmHruwye9OLQ1vGmRZ3FjgvZv41REr8sx6uussKvOPmKGnOoSeeX6R5WatN+/jv36CgmffpMn8yQbY+/MkU82fBBnE8dr+hnrf1kFu/zPb/EmcSAIUa/avhHaKovdc8ISqDOM8Ren+D3LGlcYc5qdLQomRyLxl/TZZzc8uRA3eWVTm398MI3sCrDBrvXlHjv4JTZp2tSbzJ3FVSYPp5k+W/8lmTp7b32CxJsryvxXmT+KGolrKAUDwMVH0ngueUJXhgIdHuJtozOE2xxihxEhk3jupJwvtA3mu8GyW1vwjZnjzLY9js/3cVLPWm7dpy27U0nmJZvOf5poY88y/Eea1Ii2P+/Y3WCzLYMP8SfRWtFOtjEmK/1yR9J55nlCV4YAnqaE7aWaGs8vGCyVGIvM2Jw28Z/3q4jGazD8SswLXo0OH/sid+ZPfI5satRz1i0SjZyZ6ObvQdPMn71+f5OS+/UWLU5P/WGn+JMZ5Z1A+FptRJZLeM88TqjIc8KqqgxNpZoZ13m60LcqFQDyKkR14JJHMqaL30/JmzWZIon7ceej1Be9wY/5//vPH6MLL7tI82CFR5+tGT40us8T8l2Q4hGl/p8bqfqtSVpv/SzmFtHtiPvN4mr8nkt4zzxOqMhzwPJ5gMu3McHFqlRBiZAfemijZ1simwOPZz+jNv3+c89Nb0b79R5g1f3KZ0SuvrURjWy8Ylvkr+Ge/dVRaYv6Es5Zs/hOk/Z0aSzPZMH8SdldRlwAAIABJREFUtxQoVHtiJMW/2mp9th1PqMpwwpPV4H4asbwrd4wQYmQH3rtRLlwhovh6Vh6aQk4GaDT/EyZZfza674EXwpkEWTL/det3oJmBnw3rMQcJjxpE9+S7LTP/N8Ob/8Rpf/1jc3I+M+ZPYnblIM//B7QX/50s6LOteEJVhhOepIYeoxHLYPkk7sXITryVadGXXV/NykczqsZrNv/+UTN2LrrlV79DR47+0VLz37hpF5p7wW2aNzj2Dy/+2V35HsvMn8TqlDzL24tRPHKtMSvmT1bBxni7qdqL5OtuZ0Gf7ciztHC78XBjn0Ujlj78/c2JxVyLkZ14m/s2XkUTS5I0aHZF27DMv79YVjecjW64+bdo7bpt6MsvvzTF/D/++O/omecXhzco0s3kBjf/Wl8P+q2jylLzX5TpQFsZaC9G8MiNhosZMX8Sj0c7/x/N/JXA57Lc+30W9NluPEsLtyNPrpk1Ajf6YzTLwk9lKdyKkR15b/XlBogmliQuLm0atvmf2l4mTJ6HfvPgS+Gjd198QTcYoDX/P/35L+i1N1ahS+bdjZS6OcP6/zv1d8d6ZqKnRpdaav6R2T8r7UVv3toRecyYPwkNp2HeYkWf7cSztHA783DD30jzTPjy4nZuxciOPHKsLJZY3lRYHV7dicf8B8ysG89FF156J3r08VfRsrc2oPcOHEWff/4Flfl/9NFf0abNu9FLf1iObvnVE2jyjGviHpyc+ruTXZPCu8GtNn+SvIml9qI3j9SPFfMn0SV10baXK1nSZ7vwLC3czjxZ8f+c5plwo6c7qiDwIEZ25S1Ld8QUyydyy1GrZ7ou5jpY+PDMvWPS5Wh6z3Xha3nPveA2dNHld6Kzf/rL8Aa+iVPnoYaW8+N+LBHret/LS8eiRSPZSEm7MdnJXHvRi7eBYvBppvmTux3cCl17cVUHKljSZ7vwLC3czjyX0u2lFfM30l3ciZGdeRsTnWhhZmyxfC07P/oOaR3MnwVevbcb/caCu/0H45Fb/1hsL3rxluP6sWL+JG4sqqZqL5Ia+ossz/smS/psF56lhduZJ8vnfVNSgx/RCO51zmbuxMjuvNWpg6dhPTXuyZfROM9MYcyfZDmcU9GGXs4pMM1sYvHInf/bErTP/nlpf1vJoHNk7JUnMz+Pqa6JtO3vadb02S48Swu3O09Wg0/SiG6Le2a4o/MiRsDDkTB4KtZo8UZWHppXMgZ5FT/X5t/pnhpzl7/Z5k++vy4ln+n2Ei/vnZQ8psyfDP7ctO1PCU5jUZ/twBOqMrzxcOMfTyu+8zNkbsQIeMdj0yDpWIcS3ydHl6JAZQfyhAcC/Jg/uc+fLPnGetZvhfkvH8bGP97aH7nYiBXzJ3FjYTVt+/usrHruD1jUZzvwhKoMbzxZDv67rIQ+oRHfK4uauREj4H0VNI8Coonv06NK0LnlzeEb81g2f/Lo4vqiWrQgi/6Rh5nmvyTTgd5N5Ke9DIe3JjmfKfMn75vqmkDV/iQ1+Aqr+mxLnlCV4YAX8zFAX8cZ652FtiSyL0bAGxjLh3gUEEt8n8MDgQvLmsIb6lgxf7K0O9k1Ed1W4KOe8Vth/uTnG5O1Lf2z0F608pbi9sWS+T83qgi3Ecr2pwRnsqzPtuIJVRlOeG5fqJVWfJ/NdDMvRsAbGCRPAJmJxiO+b2blogfypPDmOnWwOwQMNv+x3unoktKx6Fk8KGHFbIbikdUXHtuLFh65d4Il8yfvJ3tZaNqfpAQ/l6Tu/2ZZn23DE6oyHPFkecrpuCN8TCPmPy3tYFqMgDd46JmfnRwf/LXTgy4ob0Lt7mmGmX+1rxvNqupE/1dcgx7LLWdumXko3go8K+a5vdDyVqbTP3ox4/N4A8c4zzSq9od17zXW9dkWPKEqwyFPVgOP0szkfIofrU0uZVaMgDd0bEgxJksbuXDldqcbXVlSj0KVbWi83IVUXw+1+Xv6nuXPcJ0VftxwY6GKHs6tCOcvYOlcOS1vWaYjfCc+7+0lFi9aBkqrP4/78iTqwadLDfbwoM9C84SqDKc8lxoYS7uMe4ejgUkxAh5drDHxrvY/ZBegZ0cVh28dJEfzyKU8d+e70QN5LvQ4/t7To0vC1/P238DHSha5YZt/hrZNf6y3l6F4Wu6aMOvzIANQqpUnJfhpZe3sH/Kgz0LzhKoMpzxyC5ashA5TnbOWplOLCc/iJjLv7RH5XJor67ylOLYm0V/2w0t7icYjlxotYezzeDnbiZTI8dUYq06SGvw9L/osNE+oynDMk3yB62if4c7PdDMlRsDTzluZmseVubLOI5sstyTaw/zJz9/ROPs34/O4tqiO+rGTpPbW8aTPwvKEqgzHPEmZlSEr/i9pNnBdVNLBlBgBb3i8tX17Alg3V9Z5YfO3ycyf/Fzrs38zPo8FWWTz3xDJrU4y/9DB9vb2b/Ckz8LyhKoM5zw8AFhIs4GGpJJdnRR9MyDv4mY33kYyCMhkS8x54i3Ff7utNpr5k9Ay+zfr87gz3019wkRSQtfwqM9C8oSqDOc8PACYRHt068b8JibECHjx8zYn5YefX7Mi5rzwyAVLWhL8iNBetiXGTrBkxecx2TWJdgBwzOOZncajPgvJE6oynPNKGqb8P1kJfEDTkeq9PWhLYrFQ4mZnHlnWjefGQNbNWm/eqlRHOOESL5+vXjza2b+Znwc5UaLhfokFvOqzyDxLCwfeVzxJDd5I25nuG10nlLjZnUcMbVXaQIHn3az15JGd7+tTxL/hLxov/Oyf4nGR2Z/v2RXt1AOAqureTp71WUSepYUD72SexxNMJldk0nSmDmkG2pZQKIS4Ae+rIPfXL83k36z15r2Voe15P6uf73B50QaHVn++L+YUIu9gV1MPmP2H3pPl877Jsz6LxrO0cOBF58lK8HeUy2noiSyvEOIGvJNje4ITrUgz79Ig1nlrUvM0/x1Z/ny18sL5JBj6PCK/c1FZk5bNfxeIoM8i8SwtHHjReW41WEpj/iRmVk7iXtyANzhvXbITvZnBl1nryVuRnqd51s/T50vLWxlj9m/F5zs/u3DwxFQDzD/w9wp11o9E0GeReJYWDrzBebISeiuW+UfuDHg+A7IEiszbSvYGjMjTdFzQanOIl7ckw6E5lS+vn28s3qbkoe+LsOrzvbR0HO3GP6JTd4mkz6LwLC0ceIO/ZDXYRmP+JGZVTuJW3IBHzyOPBdaOyI+aWpg1cxgubzE2/jXJTrSdg8/DLB7Z+8Da5/tKdgGq9vkpzT94TFJmOETSZ1F4lhYOvMFf5KYs3IF2xzL/yPdezoh9PTCL4gY87Txy9n31iLwTGwVZM4fh8N5Kd4Qfd/D4eRjJWzdi8KV/Kz/fy0vH0po/0an5Vusp8KLzhKqMaDzceXppzJ/8vLuyiztxA158PHJskKQYjjZD5MH8F2c6womRNieK8XnozSMpjQe7IMrKz5dkmawh6abpzB+5lVk+FvQUeAN5QlVGNJ4sTzldVoOHaLIEkqBdBWBB3ICnL4+kwCU75ZdhU2XZ/MnjC3KcLTzbZ+jvxyJvsHS/Vn++V5TEmP2frFdLWNFT4FHwhKqMADxJCcyhzRLYUxF7FYAVcQOeMTzy7Hx9cn442+CbGQ4mzJ/ccLg6Fc/0k5zhVQuW/36s8Aa79Mdq838pp/B4yl/KDcpuX3cNS3oKPDB/rngeT/N3ZcV/iCZLIInnRnqYFzfgmcfbnOBE61Lyw1fIDrWZTC/zXzLSgVZgwyflbcSz/G39jvDx+Pezihft2J/V5k/ivPIWavPHurWCNT0FHpg/dzxJ8Z9PY/4kJknT0PaEQqbFDXjW8XbgAQFJnbshOR+tGZGHVqWTgYEDLcvMPemimVjX8ZJHDSvxe99Jc4RPJhBe+Lx+Alv15ZG3MWVgul8WzP/p0SXIow6iP1EeU7qVnjEs6inwWCoceDF5Hk/z93CHOkyTJZDEQzk1zIob8NjmhZfoE4+vHGzGhr6pL8jX24i5D2LwvNaXNR4ZoC07JSkUC+ZPoqdqPLX5S0rgbVb1FHisFA48ah7uYD+lunQDR4t7JtratwrAkrgBD3jAGzpOzfbHivn/1lFFbf7kazwAqGdZT4H31RvEqYzAvLKyuWeEk2lQDgJuc4xlTtyABzzgDR6bk/KZNH8SXdIkavMnO/9Z11PgffUmcSojOM+l9s6gHQDU+rrR6qQSZsQNeMAD3hDvx7//Vr8bHlky/187PRrMP3hMVvxlPOgp8L520gCA/8oIziO3A0pKaDPtDVxXFrYwIW7AAx7who7V/W78Y8n838jKQ82eGbTmT37+NC96CryvnRgAiFEZG/Dk6lAD7SUcHhyvp7ksFzfgAQ94gwc5PcGi+ZO4sqSB2vzx5OQLlxLI5klPbc8TqjI24eHOtoB2Q86Myi5IrAI84DHKI7+7PN3BpPk/n1N8crrfGDeSSmrwLh711NY8oSpjE57kCxTjDneMdmT+SHa1EGIJPOCJxosk+2HN/El0V02gN38l+HdXTff/8qinwLO4cOBp58lq8AnazjnOMwttSiriXiyBBzyReOS+BXJzIovmf2++TG3+xyN4uZn6Bzwwf1vzXNWBRDLqpk0UdF1BM9diCTzgicQjv0+uZmbR/Bdm5aFWz3Qt5r+/sKH7O2bqH/DA/G3PwwOAK2gTBXnw9xalVnEplsADnmg8suufRfMncVXJGA3mH0JSdW+TFfoHvPh5lhYOvPh4xxMFBXbTJgqaVdk1qFixLJbAA55IPJIVkVXzf3ZU38Y/WvNXQq9apX/Ai59naeHAi5/n9nW30iYKInHf6DquxBJ4wBOJtx2/d2mmg0nzJ78/3XWWBvMPfi6r/tFW6h/w4uNZWjjw9OHhDjqfNlFQrdePVqWUcyGWwAOeaLyVaWyaP4lfFKrU5t8XN7Ggf8AbPs/SwoGnD0/y9Wbg0fi/aK8JPrtsAhdiCTzgicRbNyKfWfN/MacQVfu6qc1fUkMHS2p7v8eC/gFv+DyhKmNnHh4AXEc7ACDxaLbCtFgCD3gi8bYmFqBFjJo/iZ7KDi0zf+RSAi0s6R/whscTqjJ25pFsgZIS2kk1AMCdut7bjd7pnyyIIbEEHvBE4pGbOJdkOJg1/9tJsh8N5o/jZdb0D3g68YSqjM14biXoG3BD4BDXBV9U3M6cWAIPeKLxVqbmMWv+f8guQHW+mfTmr4T+Su4gYVH/gBcnT6jK2JQnqcH7acw/Eo9lKUyJJfCAJxJvXZKTWfMn75tT0aZl5k/u+5/Dsv4Bb5g8oSpjY15Z9dwf4E56lMb8ydcNnllobXIpE2IJPOCJxNuCGW9mOpg1/7vJdb8azB/HKpKSnGX9A94weEJVBnhkQ2AHjflHOvvcvlMBIokv8IBnNW9Zeh6z5v9SthPVn7T0H8P8leCnnurePB70D3hg/rbnudTQczTmH4kHR9UIJb7AA56VvHdGsGv+5P2B8K5/6pk/GizZD6v6BzxKnlCVAd6Jl1zbm4A798e0u3trfX60st8FQTyLL/CAZyVvY7/n/iya/82FijbzV4JrCgu7BxwZY1n/gEfJE6oywDuJ51IC3Vqe8c2s6ELbEwq5Fl/gAc9KHjnvv7jvyB+L5v97cte/r0eL+X8qKaFcHvUPeBQ8oSoDvAE83NFf1JIr4A5HA7fiCzzgWc1b0Xfkj0XzfyMrF02SJmlY9g/f938Jz/oHvNhvFqcywBvAc9VM/4mk+I/S5grwqkH0WrrEpfgCD3hW8tYlO5k1f8KZV1KvyfyjLf3zpn/Aiw0QpzLAi8pz+4KtNOYfiXZ5BtqUVMSV+AIPeFbytiQWoDczHMya/yO5Fcir+OnNXw3+w6UEskXQP+DFgFhWOPBM40lK4LdaBgEXlHRwI77AA57VvOVpecya/6tZ+ajFPU2D+YeQSw2FRNI/4On4Yr0ywBvIU5Tu/8Cj+v1UA4A+obh/VDUX4gs84FnJW5ucz6z5k5hT0arJ/CU1+AqWjNNE0j/g6fRivTLAG5ynNVeA4utBC1MrmRZf4AHPSl546T+TXfO/7USiH1rzD/1RloM/ZkGvgGc8z9LCgWc+z6WEfkFj/pGYIE1DmxOKmBRf4AHPat7yNAez5v/kqJK+I3905t/37L+NJb0CnrE8SwsHnvm8nPZ535KU0Goa8498b15RG5PiCzzgWclbm+xk1vxfycpDbe6p2sxfCd7Nml4Bz1iepYUDzxqexzM7TVKCH9OYf+R3HqK8KphXMQce8LTwSKKfJZlsmj+JsytaNJk/nhRsLmzo/g6LegU843iWFg4863gnEgZR5gpQ8NcL0lxMiC/wgGc1b2VaHrPmf+K5P7X5B/9e6Z2dw7JeAc8YnqWFA89aHjb7B2lzBUTuB9iQWGK5+AIPeFbyNqQ4mTX/E8/9NRz5rVJDU3jQK+DpzxOqMsDTypv2fUnxb9OSGGRO2VlRBZVXMQce8LTwtuF/lw5j6d8M838tKw91yJM1mb+khH7Dj14BT2+eUJUBnnae5OspwYOAf2k5KnSbY6wQYg484GnlvTOMpX8zzJ98HX7ur838w8/9edIr4BnME6oywKPiSUr3bC3PDD1KCL2Q6eFezIEHPC28zUn5zJr/DUXVGs3/+HN/HvUKeAbxhKoM8DTxtF4VPNbTjVYll3Er5sADnhYeiWUZDibN/0FHVTiJl9bn/jzrFfB05glVGeBp5pWVzT1DVoNrqUVECaKpVV1oU2IRd2IOPOBp5a0ZoW3p3yzzfy6nGI3xdmtd+n+Ad70Cno48oSoDvGHz5OpguqSG/kJj/pHTA1cWtnAn5sADnhbetkQnWsKg+b+elYcmaNz0hwf52yvGTvmuCHoFPB14QlUGeHHzXGpgrDxUvoAo9wY8kFPNjZgDD3haeSvT6Wf/Zpn/Ihy9lR3aZv5q6J8eNZQnkl4BL06eUJUBni48PEu4ntb8ydfk3PHi1CouxBx4wNPC25BMv/HPLPMn3/9ZcZ3GmT/pv4GpLOgL8BjiCVUZ4OnCa29v/4ashBbSmH/k9ECnNB1tSqJPGiSCOQBPbN72BPoz/2aa/6OOCs2b/iQlcBcr+gI8hnhCVQZ4uvHKVf//SGroII35R+L8kk5mxRx4wNPKW0V55t9M838124nGeWZqnfkvqapq/g5L+gI8RnhCVQZ4uvJkxV+GxeNTLdcF3z+6jkkxBx7wtPA2Uy79m2n+5OeBqk6t5r+/UplyJov6AjwGeEJVBni68ySlZy6t+ZMgSYMWDrIfQBRzAJ7YPPL1WxRn/s02/xsKazUu+wf/KflmlrOsL8CzmCdUZYBnCE8mlwRR5gogMUGahjYnFjEh5sADnlbeWooz/2ab/xOjy5CP9EHqmX8QDwD8XTzoC/Cs51laOPDY5rndE38gKYHNWq4LvqKojQkxBx7wtPC2JTjRkhgb/8w2f/Lcv9kzXaP5B27iRV+AZy3P0sKBxwcPC0uWrIT+qmUJ8rFsVShzAJ74vLfThl76N9v8SWg67398v86SurrqM3jSF+BZw7O0cODxxauq7u3UMgCo8fWgpSnlwpgD8MTmbU5yMmf+txUoWmf+f5RrZo7gUV+AZz7P0sKBxx/PpYbuoZ+JBNGUqsloS2Ih9+YAPLF55PvLh9j4Z4X5P59TjKp9fg0z/+AxtzJrHM/6AjxzeZYWDjz+eLI85XRJCa6nMf/IyYGf5zdybQ7AE5+3LmXwY39WmP+iLAea6pqoxfzJpr+bedcX4JnLs7Rw4PHJ89QER8lK6BMa8yfhwfFShptbcwCe2LwdCU60NDP67N8K8ydxbXG9JvPH/eyd0obJ/y6CvgDPPJ6lhQOPXx4WnZk05h/5Xqs8A21MKubOHIAnPm91avRjf1aZ/+9yy+mO/H018/9IUmZmiqQvwDOHJ1RlgGcuT1ZCj9CYf+R3Li7u4M4cgCc2b+sgqX6tMv8FWXmowz1Vy8wfR08XC3oAPP54QlUGeObySmp7vyepwV20uQJIPJ6tcmMOwBOftyLKxj+rzJ/EhWVNGs0/cA8regA8AXhCVQZ4hvMkn78Yi9FntNcF13t70KqUci7MAXhi86Kl+rXS/H+TJyG3JvP371CUKf/Jkh4Aj2OeUJUBnmk8SfFfQZsrgIS/YhLanlDItDkAT2zejoSBqX6tNP9Xsp1orHcWtfnjPve5W5lVxaIeAI9DnlCVAZ6pPHLrmKQEltHmCiBxh6OBWXMAnvi8Nan5zJg/iXMq2rQs+5Pn/teyqgfA44wnVGWAZwlPUqenYoH6kOroEg6yy/nN1EomzQF4YvO2hTf+OZgx/3vzZU3mjwfba6qqmr/Dsh4AjxOeUJUBnqU8SQl20Q4ASHS5pmLhLmTKHIAnPm9VWh4z5v9adj4a65mpYeYf+MRTPX0UD3oAPA54QlUGeJbzJDX0GPUgAAvbzfkNTJkD8MTmkWN/rJh/zKX/KKdrJKV7Nk96ADzGeUJVBniW82T57O/LanA/7VEmj+JHr6a7mDAH4InPW5nuYMb8h1z6j3q01v96SkrSaTzpAfAY5wlVGeAxwZNqel2SEvqCVtzGS1PRxoRCy80BeGLzNiflM2P+Qy79RzX/wIdyTSiBRz0AHsM8oSoDPGZ4eADwc3pxC6IbnOOEMhvgscUjv0+y/bFg/kMu/Q/SP1xqqNPM/gs8m/CEqgzwmOHV1vZ+W1aDG2nE7fijgCB6LV0SwmyAxx5vfXI+M+Y/6NL/oP0j8LzZ/Rd4NuEJVRngMcWTfLOdWNg+i2X+EQHskGagLQlF3JsN8NjikUt/lmQ6mDB/svTfGG3pf5D+ISmBP8ly8MdW9F/g2YdnaeHAE5cnq8GrtOQK+L+CZq7NBnjs8daMyGPC/EmcW96iYeZP+kfvJCv7L/DE51laOPDE5hUXT/03WfGvo80VQB4FzM+QuTUb4LHF24bfvwjP/lkw/wfzXAPv+h/C/PHs/0Wr+y/wxOZZWjjw7MFzebvzsJj9kzZXQKc8PeqjANbNBnjs8Vak5jFh/guz8lCrexq9+auhv8i1vZp2/fOiB8Bjh2dp4cCzD09W/JdpyRVwg7OJO7MBHlu8TYlOtCDTevMncVlpo4Zlf/I7waks9V/gicmztHDg2YdX0Nr0bUkJLqW9JZA8Cngj3cWN2QCPPd6ytDwmzP/J0WXIqwapzV9Sg6/jbkR94Q+PegA8NniWFg48e/E8Nf6ReGbzD9pBwETIFQC8YfI2kNk/A+a/KMuBJsld9OavBD+uVOYksdh/gScez9LCgWc/nqyEzqEdABBR/GUe5AoAnnbe0nSH5eZP4vqiWg3L/iHkUoM9LPdf4InFE6oywOOAN2/e1/EsZxmN+ZNQFD9alFrJtNkAjy0eufSHBfN/IacYqbj90po/Hhwv/Brl0r8wegA8S3lCVQZ4fPDIowBJDf2TNlfA1KoutCWBTbMBHns8Mvu32vxJdFdNoDZ/PCj+l0sJZPPQf4EnME+oygCPWR4WvEu0XId61+h6Js0GeGzx1iU7mTD/Xzl99DP/47v+L+Op/wJPQJ5QlQEe0zxZnvdNSQmtpj0apfr8aHlKOVNmAzz2eEv7Ev5Yaf6vZBegMd5uavPH/WAbyZ3BU/8FnmA8oSoDPC54JFeApAQ/p50pBSsmMmU2wGOLt7Yv4Y+V5k8inOmPduavBL90q72VPPZf4AnCE6oywOOKhwcA12nJFfDbnBomzAZ47PHewrN/q83/t45K5NbQniU1eJeZ/Q14wGOncODZnldT0/NtWfFvoc0VMMbbg9YllVhuNsBji7cBz/6tNv9FIx2oQ56swfxDR6rGBP7TzP4GPOCd+gZxKgM8LnmyMqNKUgJf0OYKuKy4XSjzAl58vO04lg1j9q+n+ZO4triW2vz7Nv61WdHfgAe8/m8SpzLA45YnKf7baXMFkIxqL2a6hTAv4MXP25Ciffavt/k/P6oIKUoPvfkrwflW9jfgAS/yRnEqAzyOedO+j0VxN+0tgR3SDGwCRdybF/Di5y3LsNb8yfv8VR0azD/0iUvtHSFW/wUelzyhKgM8rnluJVRDfU0wjlvyxnJvXsCLj7de4+zfCPO/J1/WsOwfHgCcw0J/Ax7wviZUZYDHPU9SAo/TDgDINcFLUyq4NS/gxcfbcaYTLcu01vxfy8pD4zzTqM2f3H3R3t7+DVb6G/BszhOqMsDjnuf1zvkRniF9GHMA0Ce0gfKJXJoX8OLnrdMw+zfC/Mn7Ly8Zo2HmH/xSVvxlLPU34AHP8sKBB7z+LyyUARrzjwjvwzkqd+YFvPh45L9pd/4bZf6/H1WCfCc2/lFsYFWCd7PY34Bnb56lhQMPeANe8+Z9XVZCb9GYP4kGz6wh7wZgzbyAFz+PdvZvlPkTzsyq8VrM/8+S1P3fTPY34NmWZ2nhwAPeYC9Z9Y/GwvlZLPOPfO+KolZuzAt48fNobv0z0vxvc3rozf94253Fcn8Dnj15lhYOPOAN9cKieQON+ZOfe/C/r6TLXJgX8OLj0Zz7N9L8/5Cdj8Z4Z2ox/7fJqhbr/Q149uNZWjjwgDfUq7Ch+ztYQHfT5grock1F2xPYNi/gxc+L9ezfSPMncXFpoxbz/9JV3VvCQ38Dnv14lhYOPODFesm+QK2W61XvHV3HtHkBLz7exhh3/htt/k+PKkFexU9n/sfP/N/BU38Dnr14lhYOPODR8CQl8DTtUat6bw9am1zKpHkBL37e8iFm/0ab/1cb/+jMX1KDf/L5Qv/FW38Dnn14QlUGeGLy3O5piZLi/4h22fWKojYmzQt48fE2Jw0++zfD/O/Nk+hn/seX/6fx2N+AZx+eUJUBnrg8l+KfQyu+ZEPga2kSU+YFvPh5K9LzLDN/cuNfi3uaBvMPvYWb8mm89jfg2ZQnVGWAJwzvh72hr2NhXUUrwJOryIbAQmbMC3jx8Qab/Zth/uTrcKpfyrYnKaEvJN9sJ8/9DXg25AlVGeAJx5N8oXLaqGrwAAAgAElEQVQssMdohfg3o2uZMC/gxc9bmTZw9m+W+b+UXYhqfD30AwA1eJsI/Q14NuIJVRngCcuTlOCDlM9fUZ23G61OKrHcvIAXH29rotMy8yffP6eiTctz/z+TjX+i9Dfg2YAnVGWAJzSvXPX/D55hfRTL/CNHB+cVtghlhnbkrTrl2b+Z5v94bnl4T4mGZ/9+kfob8ATnCVUZ4NmCJymhs2nMn4QHx+tpLmHM0G68d0+Z/Ztp/iQmSpO1PPvfLMvnfdPq/gE84FHzhKoM8GzBI/nUJSW4Ppb5R+4NmF7ZNSwDY80M7chb1e/Zv5nmT35+S4FCP/M//uxfZaF/AA941DyhKgM82/CwsVedtCEwxnXBD+fUcG+GduNtSyxAizOtMf/XsvNRg3eWhtl/4Pcs9Q/gAY+KJ1RlgGcrnqwGHqUxfxKN3m60KamIWzO0I291ap4l5k/i0tJxGsw/+E+Xb3oma/0DeMCjebM4lQGerXgVSugn2OT/Spsr4OfOJm7N0G68HQlOtCTTYYn5PzeqBPlIO6I8bSIp/utZ7B/AAx4NQJzKAM92PFnxX0SbKEjB3185opw7M7Qjb92IPEvMn0SgqlOL+R+tqJ7836z2D+ABLybEssKBB7w4eVVVTf8PG/+7NImCSJxf0smdGdqNR96zNMMa838ktxK5Kc0/PADwdU9nuX8AD3i6v1ivDPDsxXP7umuo87PjmJ8hc2OGduRtSM63xPzJ111SF735K4E1Rc2Np7PeP4AHPN1erFcGePbkYUF+mnbT1tSqKSfMiXUztCNvWbrDdPMncXuBj9r8ZSVwDM/+Xbz0D+ABL+4X65UBnn15Vb5AqqQE/0U7CHgku5oLM7Qbb2OS0xLzX5CVh5o802nNn8z+H+GpfwAPeNF4lhYOPODpyZPU4I20A4Am90y0IaGIaTO0I295qsN08ydxXVG9BvP3/93rnZLCW/8AHvBO5VlaOPCApyevonH6d/Eg4CjtMu4v8scybYZ2421JLLDE/F/JdqI6XzeV+YcHAL6eq3nsH8AD3qk8SwsHHvD05mGhDtDO5FRfD1qRXMakGdqR93ZqvunmT+LCsiZq88fxvqu+8we89g/gAa8/z9LCgQc8vXkkT4CsBjdSijm6qLiNSTO0G28rnv0vynSYbv5DXvoT9YbJHj/P/QN4wOvPE6oywAMeebnUXi+dmAf7sgVKTJmhHXmrU/JNN38S/spBLv2J0l4kxf8uyfZndnsGHvCM4glVGeABL/LCIv5yLPOP3Bswo3KyJiPjzVx54C3JcJhu/oNe+jNIe3Er/jFWtWfgAc8UnlCVAZ5teVJ1bxYW889oEgWReCJLYcYM7cZbl5RvuvmTn0+UJlObv+wLLrSyPQMPeIbzhKoM8GzPk5TAbbSJgjrl6WjbmYWWm6EdeSvS8kw1fxK/cka59GfwweIxT3Wg0Or2DDzgGcYTqjLAAx5+n8839cdYxD+kSRRE4r7RdZabod14ZPOf2eZ//NKfGbTmjyP0CAvtGXjAM4QnVGWAB7x+PFnxn0ebKKjR0402JxYJY6488N5J1T77jzdL4A1FtdTmL6mhf3o8wWRW2jPwgKcrT6jKAA94p/BItkBJCWyjTRR0a95YYcyVdd6OBCdakmmu+b+elY/qfbPoZv7Hf34DS+0ZeMDTlSdUZYAHvCg8ty8wjvaK4DpfD1qfVMK9uf7/9u4EOI7qzAN4SLKw2YQctUuOtSTLkiXbsjTSSLKsa7pHmteSbGN8yge2seVDmukWRxKODUnFBAhFICEHxy4khiwsFFkWqhYnOMQ2xsYYQxxsjG1soNhkISQhBDYhYTcB3NtPR0hsafrrmT7ee/NX1VeJpNLv+fV7xf91T3c/GbwDk+pCDX9elzfNIYe/Zpiv6vr5HxVtPsOD55unVGfgwRvH05i5m7oIuKp+gfThKoO3pyIWavj/cFq93e0s8Ehn/nwBwKzzRZ3P8OD54inVGXjwxvGc/7C3UxcAzAmDR0tbpA5X0b3DxfFQw5/Xpc3zyOHv/P8XenoGTxN1PsOD54unVGfgwcvi6cy633UBMBIEn2tcLG24yuA9UU47+/cr/DdPbxx+5S/xvRDtXYNLRZ/P8ODl7SnVGXjwsnj85UAaM99yC38eCvwVwdvL2qUMV9G9Y87Pd4UY/rw+07KQHP4as/Y50+UU0eczPHh5e0p1Bh48F8/5j/tt1He/n9e8TLpwlcF7knDzn5/hf+/0pqEFHfWlUElmdcsyn+HB88OLtHF48MLyOjv7J+iG+Sb1OfAtFbpU4SqDt7sivPDnlWlbQg5/zbAekWk+w4OH8IcHz4Pn/If/a9RHwda3nSNVuIruPV2S/eY/v8P/rppW54yeFv7DZ/8ZXbb5DA8ewh8ePOJX+5zMx3RmvUb9TPjeqSkpwlUG7/EsN//5Hf7879YklpPDX2OZzTLOZ3jwcvUibRwevKg85z/2l1IvC6/Q+uxjRdgoKF/vGH/zX4jh/53aBDn8nZ+/09E1WCvrfIYHLxcv0sbhwYvKa29f9WGNpV+kbhR0Z1WX0OEqg7d/0tjv/Q8i/Pnfn62vpIX/8Gf/d8k8n+HBy8WLtHF48KL0EmzApG4UtFRbO/T4mqjhKoP36Bhv/gsq/G+MJ+nhz8y3NHZehezzGR48r16kjcODF6U3a1bXB5yAOELdKOiOE64CiBSuonuHS05+9C+o8N/m1JLkalL480oY1i0qzGd48Lx6SnUGHjyvns6sXuorgpfoa/98L4BI4SqDd+K2v0GFP3e+Fe8ghz/f7jfRlSlWZT7Dg+fFU6oz8ODl4J3C3/xGXQT8a1W3cOEquvcsf/NfZTjhv3VqzF6cXEMK/5Gb/76m2HyGBy93T6nOwINH8BJGZi51AbBYX2sfLmoQJlxl8J4qrQsl/N89+6eFv7Pwe6PFSH886vkHD54QnlKdgQfPg+cExuOEs8Wh2jS9S5hwlcF7bHIslPB/97N/2j0dTl0myvyDBy9ST6nOwIPn0dOYOZsS/vyz5UXJtfbh4gYhwlV072hxfSjhz+v60bN/QvhrhvlqU8/gh0WZf/DgReYp1Rl48HL0nEXAXrfwH61N07sjD1cZPL7xTxjhv230s3/iRzmaMXixaPMPHrzQPaU6Aw9eHp6eMnso4c+/X5Bc5wRjo1JhHYS3uzIWePjz72/gZ//k8DdfbT1r7emizT948EL3lOoMPHh5ek6473IL/9HLzLdWz1IqrP32DpXEQwn/h5yz/yVezv6ZdYmo8w8evFA9pToDD16entZlGZTw57UwuZ58FUD0sA7Ce6y8NvDw5z+/oT7l+exf1PkHD16onlKdgQfPB09PmTupGwVtmt6jRFj77R2ZELd3hBD+Ozye/Tv1OdHnHzx4oXlKdQYePB+8JOvvpu4i53YVQIawDsJ7cmI88PDfmcvZ/9zVp4s+/+DBC81TqjPw4PnkOcG/i/o62e+Mcy+ALGEdhLd75PJ/kOHPz/57k30ePvs3Py/L/IMHLxRPqc7Ag+eTp7MNSeob5Rbp6/68R4CMYe23d7i4PvDw93z2zzKvJ5Nrz5Bl/sGDF6YXaePw4InoOaGxgxow/zatS8qwDsL7ycS6wMPf02f/Qwu59Bdlm3/w4IXhRdo4PHiielr3YIK6AFip9Q0FoWxhHYT36ORYoOHP6ybqc//DN3O+xtjZZ8g2/+DBC9qLtHF48ET3NMPaRl0E3DulQ7qw9ts7VBTPKfi9hD+v5fpqYvibtsbSX5J1/sGDF6QXaePw4InuJZmZop5prmtdKVVYB+Htn1QXePjfWqt5CP/M/2izVn1c1vkHD16QXqSNw4Mng6cb5h5K2PCnBjZX6NKEdRDe6M5/QYU/r77EClL48/HQUgOXyz7/4MELyou0cXjwZPA0w1pACRteVvNyacLab+9osffL/17D/66aVnr4v3v2L/X8gwcvKC/SxuHBk8Q7RWPWIbfw55V0vt9enhA+rIPwDni8/J/LLoGZ9qWk8B+ugSsVmX/w4AXiKdUZePCC8nTDXOMW/qM/u6RpqfBhHYS3p4J++T+X8L+3eqbdMd57GU4YD+fs/41WY8MnVJl/8OAF4SnVGXjwgvIaGvr/RjOsn7qFP/99B7PsPaWtQoe1395R52dBhj+vC1oXEc/8eaW/rtL8gwcvFE+pzsCD56OnMet8yi6BvL7UsEjYsA7CO1BKu/yfa/hvnt5op/ixJoW/+ac2NlgS9XyBB08qT6nOwIPns9c4Z+3fOWeWr1A2CmLOz/ZNnClkWAfhUe7+zzX8ef1T83xq+Nt6ytwkwnyBB08aT6nOwIMXkMdfKkPZJZDXNfH5Qoa13x6/+39XgOG/ZVq9bbA0LfyZebyt89wqUeYLPHjCe0p1Bh68AL02Y90nnLD5HWWjoJ7OtH2weIZQYR2E95TL5f98wp/XZU1nUsOf130izRd48IT2lOoMPHgheE7gXEfZJZDX9bVzhQrrILy95bWBhf+2qXX2rNQALfyd32spq0W0+QIPnrCeUp2BBy8Er7NzwwSNmf9HWQDM69hgH53QIExY++0dmzD+3f/5hj+vqxt76OFvWA+LOF/gwRPWU6oz8OCF5GmG+W3SHgHG8FbBIoR1EN5TE8e+/O9H+D80JWbP61xHCv+hSpk9os4XePCE9JTqDDx4IXkaO69CY9bblAXA6vZzhAjrILwnxrj870f48/pGPSOHv8bMA86wnCLqfIEHT0hPqc7Agxeipxvmv7suAEaC6oHJWuRhHYT3SEDhz2tpcg3tzH/4OC8Xfb7Agyecp1Rn4MEL0eM3nFE3pvls05LIw9pv71BJPLDwv6024SX8X9D1je8Xfb7Agyecp1Rn4MEL2XPC53HK62k7WNp+rLRFmfDnta+sNpDw57WhfRkt/IePdUaW+QIPnohepI3Dgyer195lrqC+oe4r8XnKhD+vR0c2//E7/O+b3uQsmDLE8Ld+1dz86Q/IMl/gwRPNi7RxePBk9oY2CWLmi5RH1WZ3DtiHihuVCP9niuOBhD//u4ua59HCf/jmv0tlmi/w4InkRdo4PHgqeLphfoF6t/qt1bOkD39e+yfVBRL+D0yL212pfmr4/759TuZjss0XePBE8SJtHB48Fby2nnPPcMLqTcpn1mdra0mBK3L489ozOeZ7+PO/v6qxmxT+I5f/b5RxvsCDJ4oXaePw4KniOYF1G/Wy9ebKpNThf9Sphyr9D/+tU2P2vI4+Wvgb1vEEy0yTdb7AgyeCF2nj8OCp4ulsbdwJruOU8Dq/ebm04c//bv/EOt/Dnzs31SWp4c9f+7tF5vkCD54IXqSNw4OnkueE1w5KeHU4v99T2ipl+PO/f6ys1vfw57U6cTYp/Md77a9s8wUevKg9pToDD16UXjI1sJC6S+CV9QulDH/uPFwZ8z38766eaSep4W+Yz75n48b3yj5f4MGL2lOqM/DgRemdMWi9VzPM5ykLgO7OjH2wZIZ04f90cdz38Od1fstCYvjzy/8ZU4X5Ag+ecJ5SnYEHL2RPZ9YFlBDjdXPNbKnCn9e+0jrfw39zVb2dYmli+Juv67r5IVXmCzx4wnhKdQYevAi81rPWnq4x87eUMFuq9dlHJAp/XnvKa30Nf/79ZU2zSeE/sgC4VqX5Ag+eEJ5SnYEHL0JPZ9Y3XcNs5PNu/kigLOHPa5fP4b99Ssw+s3MDLfyZ9XbCGJwU9fjCg6eUp1Rn4MGL2NPYeRVOuL/jFv78kbeLJNol8OkTdv/LN/z5z6+Pp8hn/84xu0+E8YUHTxlPqc7AgyeIx59Tdwt/Xik2YD8xcabw4c9//uSkWl/Dn/9+lbaKvABIGKYmyvjCg6eEp1Rn4METxNO6Bue7hf/oS2+uj80WPvz57/dOjvka/t+rbqZ/9s+s/SKNLzx4SnhKdQYePEG83t7e9+mG+TO38Oe1OLnOc2hH8fTArkr/wp/XhfzRP/Ll/8wakcYXHjwlPKU6Aw+eQJ4TXJe5hf9owN1f2SF0+B8uqfM1/LdOrbO7UwPU8H+lo2PB6aKNLzx40ntKdQYePIE8vWewSGOZtyi7BF44c5mw4c/ryUm0BQB1i+CvNnRTb/xzKn2ViOMLD570nlKdgQdPMM9ZAPwnZZfAlPO7JyfOFDL8hz7/L3e/AZAa/ryW6auJ4Z95R+9aUyHq+MKDJ7WnVGfgwRPM01h6LnV/+3+umSNk+D/Hn/+vzH4DoJfwvyPWRgz/obP/LSKPLzx4KniRNg4Pnqpe44Kz/tYJsRcou9yt1PrEC3+njhRnf/7fS/jzOq91MTH8M7bGBnpFHl948GT3Im0cHjzVPWcBsJG60c3Wck2o8Oe1P8vn/17D/0fT6myDXw0hhX/mF+3t8z8o+vjCgyerF2nj8OAVgqd3W0X8NbaUBcBlDYuFCn9ej5ePffnfa/jzuraxixT+wwuAoZv/hB9fePBk9SJtHB68QvHGfTPgCdWTStuHihuFCX9euytOXgDkEv68lo9389/Jj0oe7+jonyLL+MKDJ6MXaePw4BWKpxuDvdSX3txeZQgT/keLTv78P9fwH/fNf2O8J0FjmR/KNL7w4MnoRdo4PHiF4lX1bjxVM6xfU+5+H2hdIUT48zo4sc6X8Od1ccsCUvjz7zWWXijT+MKDJ6MXaePw4BWSpxnm1yl3vyedENw9qSXy8Oe1r6zOl/DfPrXW7jnxzX/jhr/5i4aGftrlSYHGFx482TylOgMPnsiebqSrqTfAfSM2J/Lw57Vn5PP/fMKf10nb/mZ5PbJmWF+WcXzhwZPNU6oz8OCJ7jnh9wTlMvgybU3k4f/shLgv4c+rL7GCFP5OvdOeypTJOr7w4EntKdUZePAE85yAG6SeCW+bnIgs/HkdLon7Ev7fr2qwk4wQ/sbQtr8Phjke8ODBE6FxePAKwEulrL93wu6PlDC8sn5hZOHPa39pXd7hz+uKGbNJ4T9c5uIwxwMePHhRNw4PXgF5OrPup4Th3I5++1hRQyThz//usfLavMOf16JkHyn8NcP8JfXmP5HHFx48qTylOgMPnuCeswDopWwRzOu+KalIwp///c6K/MP/zlgr8cx/6Oz/6ijGAx68gvWU6gw8eBJ4HR0LTtdY+nXKLoEXz1waSfgfcZztlfmFP6+LmucTw9+yta7BqVGMBzx4Besp1Rl48CTxnAXAJsoWwV2pjH24eEao4c+dg8XxvMN/29Cz//2k8Hd+9niU4wEPXkF6SnUGHjxJvATb0EnZIpjXXdOMUMOf176RGwBzDX/+dzfFk7TwdyphWFaU4wEPXkF6SnUGHjxJvNbWplO1lPlflL0BPt28PNTw57W3rDav8OeLh3T7ElL486ci+NMRKo0vPHhSeEp1Bh48iTx+0xtlAcCc4DxYMiO08Off75k89hbA1PB/YFrc+XcPuIf/cN0rwnjAg1dwnlKdgQdPIk9LnRunLAB43VHVHeoWwbsqa47nGv783oHr6lPU8Oc3/80XYTzgwSs4T6nOwIMnmacZ1hHKAmCweXlo4f9McX3OZ/6jjw2uTSynhb9hvtrTM3iaKOMBD14hepE2Dg9eoXoasy53XQA4IZpiaXtfSVMoWwQfLKnLK/y/Py1ud46e/bv2zbpRpPGAB6/QvEgbhwevkD3+7Ltb+I8+R79pencoWwTvn1Sbc/jzuqahixb+TiWNwTaRxgMevELyIm0cHjx4fIdA86Bb+POyWpaHskXwj8tpNwCOt1HQ6sTZpPB3zv7/2+n+KaKNBzx4heJF2jg8ePCGPgb4vFv48+KX1Q8UNwUa/rz2VNS8nWv4b/7Lnf9cyun3NSKOBzx4heJF2jg8ePDe8x69y5zsFv6jP7uzqivQ8H9u6AmA6qwLgGxbBH+lsYd29u9UR1emQcTxgAevULxIG4cHD97wlxOIT7mFP//9hTOXBRr+x4qyPwGQLfx3Dl3+X0k9+39O5PGAB68QvEgbhwcP3vCXE4qXUXbN60ql7SMBbhF8qCSec/j/oKqefPmf91fk8YAHrxA8pToDD56sXodh1dK3CO4MJPx5HSgd+xFAt/DndV2DQb783945WCXyeMCDVwieUp2BB09mT2Pp5ynvzv9C4+JAwn/oCYCy2pPeAEgJf17riHf/a8x8WobxgAev4DylOgMPnkSeE/zXUV6fO6dzwD42zscA+b4ueG95ze9zCf8Hp8XtFP+3E15qpLP0FTKMBzx4BeUp1Rl48CTzkmxAp24R/EBl0vfw5/XI5JrfeQ1/Xt+qZ8TwN+0Oo79RhvGAB69gPKU6Aw+ehF79ovmnOQH5MuUy+tX1830Pf147K2v+6DX8eaXblpLCX2OZ52QZD3jwCsJTqjPw4Ens6cz6F8oCYIXW53v4jz4C6DX8t02ttY1sl///6umG9LUyjQc8eEp7SnUGHjzJvSTLzKHeSb+3tMXXLYKPFMc9hz+vW+qSxPDP2FpqfatM4wEPntKeUp2BB09yr7n50x/QmfUHygLg29WzfN0i+ODEOs/hz+vClgW08GfpF1tbm06VaTzgwVPaU6oz8OAp4Dnh+QPKDXWDzct9C3/+dz8urX3ba/jzmte5zjX8RxYAN8g4HvDgKesp1Rl48BTwNCNjUm6oY2zAPlDc6NsWwY+VxX7jNfy/V9NCCv+hGwAN05BxPODBU9ZTqjPw4CngtbHzSqifqd8zpdO3LYIfKa952Uv487p8xhxa+DPzjZ6ewdNkHA948JT1lOoMPHiKeBqznqacWW9sWOhL+PN6uCL2spfw57VKW+Ua/iN1X5jHDx48eEQkssbhwYM35pdumFdTzqyX6H2+hD+vhyqqX/US/lumxd/d/MdlIyOty1wb5vGDBw9eQF+idwYePNm9hGFqpDPrkccB8w1//v2OKTVvUsOf1w3xTtK/z/nfd3Td/GSYxw8ePHgBfIneGXjwVPB0feP7NWb+lrJF8Hen9+Qd/scm1JODf7QuaF3kHv7G0OY/e8M+fvDgwfP5S/TOwIOnkueE6P2ULYIvnrk0r/DnPz9aHPe8AJjbsc41/IcXANYXozh+8ODBy+5F2jg8ePDG9zSW/oxbuPKa29HveiOg2xsDD3tcAPxHdRMp/HklDXNmFMcPHjx42b1IG4cHD974XqKzv9YtXEdrR1l7zuHP6+mS2j9Qw5/fKHh1Qxcp/DXDfL23t/d9URw/ePDgZfcibRwePHjZPf76XMoWwTfGzsw5/HntL619mRr+/FHB/valruE/8vn/PVEeP3jw4I3vRdo4PHjwsns6S9/uFv68zm1ZkXP48/rJpNjz1PDfOiVmd6X6SVcmEoY5oNJ4wIOnkqdUZ+DBU83TmbWSsjFQd2fGPlbUkFP48/pxWe0RSvjzNwV+N9ZGCn9e7alMmUrjAQ+eSp5SnYEHTzUv0d3/KSdIj1MWAVvLtZzCn9cTZbFDlPDfPvT631mk8NcM8/mojx88ePA8eEp1Bh48BTyNmc9QFgA3xebkFP689pbHnqKEP6/17ctcw394AWDdJMLxgwcPHsIfHjwpvYRh3UJZAFzQvCyn8Of16OTYQUr4b5s68vk/4d/jLFyWiHD84MGDh/CHB09KzwnSVa6B65yRz+7st4/kEP5DC4CKmkNu4c+/v7tmjO1/x6lWZv2jCMcPHjx4CH948KT0El2ZYrfwH30pz46yNs/hz+uRytgRt/DnP7+moZt49m89J8rxgwcPHsIfHjxpPd0wf+YW/rxuru7xHP7DC4Ca59zCn//ealtCXQBsEun4wYMHb+w/UKcz8OAp6mksc4db+PO6qKnXc/jz2lVZ81O38B9+//964kcA5hqRjh88ePDG/iN1OgMPnqKeE/Qb3MKff79E6/Mc/rx2VsZedAv/zVUN5M//dSM9WaTjBw8evLH/UJ3OwIOnqNfRnZ7iFv68elJpz+HPrxhsn1L9Urbw53VXTSst/Fnm56IdP3jw4I39x+p0Bh48Vb2NG9+rMfOtbOHPwzfp1DNFjZ7Cn98zsL2y+ufZwp/XLXVJQvibtsbS24Q7fvDgwRsTUKcz8OAp7DkLgJcoW/Bm2xlwvL0CHqqseTlb+PO6csZs1/AfrvTtIh4/ePDgjYFE1jg8ePDInhP4P6JswXtzzWxP4T+yAPhltvDntS5xNulRRI0NXCzi8YMHD54PX6J3Bh48FT2NZb5K2YI33brSU/jz2lZZ/ats4b9lWtzuNMZ5/e8JH0toxsAsEY8fPHjw8vwSvTPw4KnqJdmGedRd+EY3BqKEP//+4YqaX2fbDfDS5nm08GeZ/2Ws76MiHj948ODl8SV6Z+DBU9lLJFZ+xAnZNykb8axvXWUfK6KF/7NDjwFWvzpe+N9bPdNO8YAnvIdAZ+ktoh4/ePDg/bUXaePw4MHz5jmBez/1WfyvxOeTwn/4PQDTXxkr/L9f1WDPG+vlP+M8jaAZZr/Ixw8ePHjvepE2Dg8ePG9eklnd9JfxWPYVDQvto0XuWwTvrKx+6cTwv6e62V6U7COHv57K/MYwPvtBkY8fPHjw3vUibRwePHievVM0Zh0iLwKcYF7fttJ+cHIi6y6Bu6ZUv/CXb/z7wsyz7E7yZX9z5Pl/8yoJjh88ePBGrEgbhwcPnnev3bBWU8P/L8N6XetK+4bYbHursxg4XNRoHyhpsveUttjbyxP2DfHUS1fMmG33JVaQ7/Y/Ifx/n+ju/5QMxw8ePHguCwAZOwMPXkF4w28F3O0l/KlPD+Tqacy6RJrjBw8evCFPqc7Ag1conm6kq53g/ZMY4W/ubWjop91QJMjxgwcP3hieUp2BB09hT2dWOurwd/73N3r3QKmMxw8ePHiiNA4PHjzPXoJZ10UX/tYfnP/fHmZ/4cGDF4CnVGfgwSsUj98PYFjXRxD+ryVZRg+9v/DgwfPXU6oz8OAVoMc34NFZ+p1Qwt8wj3V0p6dE2V948OD54CnVGXjwCtjTUv0JjWUOBxX+GjPfcuS/Kh4AAAE9SURBVM78v6nr5odE6C88ePDy9JTqDDx4Be41nbn6gxqzLtYM6xd+hb+zqHjL8e5y3BrR+gsPHrw8PKU6Aw8evKHf9/QMnuaE93qndjnB/XYO4X/cCf6fOLXRy13+UfUXHjx4OXhKdQYePHgnfWla/z9oqfQ5wzcLWg85Qf/KyeGfftYJ+7s1lv5iMjWwtI2tmyhrf+HBg0f0lOoMPHjwPFj9H0kYA8Wp1JpPivjvgwcPXsCeUp2BBw8ePHjw4NGRyBqHBw8ePHjw4EXqRdo4PHjw4MGDBy98L9LG4cGDBw8ePHjhe5E2Dg8ePHjw4MGLxou0cXjw4MGDBw9eNF6kjcODBw8ePHjwovEibRwePHjw4MGDF40XaePw4MGDBw8evGg8pToDDx48ePDgwaN5SnUGHjx48ODBg0fz/h9+vXM2Kp2T+wAAAABJRU5ErkJggg==",
                            scale: 1.0,
                            width: 35,
                            height: 35,
                            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                            //heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
                            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0),
                            scaleByDistance: new Cesium.NearFarScalar(0, 1, 1000, 1)
                        }
                    });

                    // Position camera in the starting point of the first track
                    viewer.camera.flyTo({
                        destination: Cesium.Cartesian3.fromDegrees(position.coords.longitude, position.coords.latitude, 4000),
                        orientation: {
                            heading: Cesium.Math.toRadians(0.0),
                            pitch: Cesium.Math.toRadians(-90.0),
                        }
                    });

                    //addBillboard(position.coords.longitude, position.coords.latitude);

                }

                // Delete the position when I make a click
                /*window.addEventListener('click', function (event) {
                    if (myPosition) {
                        viewer.entities.remove(myPosition);
                    }
                });
                */


                // Button to toggle 3D tilesets
                let button = document.createElement('button')
                button.id = 'getMyPositionButton';
                button.classList = 'cesium-button';

                
                button.addEventListener('click', function () { 
                    let recordTrackButton = document.getElementById('recordTrackButton');
                    if (!recordTrackButton.classList.contains('on')) { 
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(fly);
                        }
                        else {
                            console.log("Geolocation is not supported by this browser.");
                        }
                    }

                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Find my position')

                // Place the button in Cesium's toolbar
                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(button);


            }



            // ------------------ create_record_track_button -------------------------- //
            function create_record_track_button(viewer) {

                const errorCallback = (error) => {
                    console.log(error);
                };

                const geolocationOptions = {
                    enableHighAccuracy: true
                };


                var gpxtrack_keyno = -1;
                var track_name = '';
                var altitude;
                var lat;
                var lon;
                var latOld = 0;
                var lonOld = 0;
                var gpsAccuracy = 1000000;
                var is_camera_set = 0;
                var has_position_changed = false;

                async function update_position(GPSposition) {

                    // Lat-lon
                    lat = await GPSposition.coords.latitude;
                    lon = await GPSposition.coords.longitude;
                    gpsAccuracy = await GPSposition.coords.accuracy
                    if (latOld !== lat && lonOld !== lon) {
                        has_position_changed = true;
                        latOld = lat;
                        lonOld = lon;
                    }

                }

                async function send_gpx_data() {

                    if (gpsAccuracy < 100 && has_position_changed === true) { 


                        // Get height for the position
                        var terrain = await [Cesium.Cartographic.fromDegrees(lon, lat)]
                        var terrainSample = await Cesium.sampleTerrain(viewer.terrainProvider, 14, terrain);
                        altitude = await terrainSample[0].height;
                        if (Math.abs(altitude) < 1) {
                            altitude = await altitude + 1;
                        }


                        // Get the timestamp
                        //var newJulianDate = await new Cesium.JulianDate();
                        //await Cesium.JulianDate.addSeconds(Cesium.JulianDate.now(), 1, newJulianDate);
                        var timeStampJulianDate = await Cesium.JulianDate.now();
                        var timestamp = await Cesium.JulianDate.toIso8601(timeStampJulianDate);
                        if (timestamp.length > 22) {
                            timestamp = await timestamp.substring(0, 22) + 'Z';
                        }
                        

                        console.log(lat, lon, timestamp)

                        // Position camera in the starting point of the first track
                        if (is_camera_set === 0) {
                            viewer.camera.flyTo({
                                destination: Cesium.Cartesian3.fromDegrees(lon, lat, altitude + 200),
                                orientation: {
                                    heading: Cesium.Math.toRadians(0.0),
                                    pitch: Cesium.Math.toRadians(-90.0),
                                }
                            });

                            is_camera_set = 1;
                        }

                        // Send position to the database.
                        await mapView3dService.sendGpxTrackData(gpxtrack_keyno, vm.model.setting.argvalue, lat, lon, altitude.toFixed(2), timestamp, track_name).then(function (data) {
                            if (data[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: 'Varsel',
                                    message: data[0].errormessage,
                                    buttons: [{
                                        label: 'OK',
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.loadingFile = false;
                                        }
                                    }]
                                });

                            } else {

                            }


                        });

                        has_position_changed = await false;
                    }

                }


                // Button to record track
                let button = document.createElement('button')
                button.id = 'recordTrackButton';
                button.classList = 'cesium-button';

                var watchId = '';
                var recordingIntervalTime = 5000; // 1 second
                var recordingInterval;

                button.addEventListener('click', async function () {
                    //button.classList.toggle('on');
                    if (button.classList.contains('on')) {
                        await button.classList.remove('on');
                        await clearInterval(recordingInterval);
                        await navigator.geolocation.clearWatch(watchId);
                        gpxtrack_keyno = await -1;
                        track_name = await '';

                        
                    } else {
                        button.classList.add('on');

                        if (navigator.geolocation) {

                            // Show the prompt dialog box
                            track_name = await prompt("Enter track's name:");
                            if (track_name === null) {
                                track_name = await '';
                            }

                            // Create new gpx track in the DB
                            await mapView3dService.sendGpxTrackData(gpxtrack_keyno, vm.model.setting.argvalue, 0, 0, 0, '', track_name).then(function (data) {
                                if (data[0].errorcode !== '0') {
                                    modalService.show({
                                        type: 'warning',
                                        title: 'Varsel',
                                        message: data[0].errormessage,
                                        buttons: [{
                                            label: 'OK',
                                            cssClass: 'btn-warning',
                                            action: function (dialogItself) {
                                                dialogItself.close();
                                                vm.model.loadingFile = false;
                                            }
                                        }]
                                    });

                                } else {
                                    gpxtrack_keyno = data[0].gpxtrack_keyno;
                                }
                            });

                            console.log('Recording..')
                            watchId = await navigator.geolocation.watchPosition(update_position, errorCallback, geolocationOptions);
                            
                            recordingInterval = await setInterval(send_gpx_data, recordingIntervalTime);


                        }
                        else {
                            console.log("Geolocation is not supported by this browser.");
                        }

                    }

                });

                // Add tooltip
                let tooltip = add_tooltip(button, 'Follow my position')

                // Place the button in Cesium's toolbar
                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(button);

            }


            // ---------------------- start_live_streaming ------------------------------ //
            async function strart_live_streaming(viewer) {

                var gpxdataJSON = await [];
                var timeline_start = await Cesium.JulianDate.now();
                var is_camera_set = await 0;

                
                // Initialize paths
                await mapView3dService.receiveGpxTracksData(vm.model.setting.argvalue, 1).then(async function (data) {
                    if (data[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: 'Varsel',
                            message: data[0].errormessage,
                            buttons: [{
                                label: 'OK',
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.loadingFile = false;
                                }
                            }]
                        });

                    } else {
                        gpxdataJSON = await JSON.parse(data[0].gpxdata);
                        gpxdataJSON = await gpxdataJSON.gpxdata;
                        
                    }
                });

                for (let i = 0; i < gpxdataJSON.length; i++) {

                    var czml = await [
                        {
                            id: "document",
                            name: "CZML Model",
                            version: "1.0",
                        },
                        {
                            id: gpxdataJSON[i].gpxtrack_keyno.toString(),
                            availability: "1970-01-01T00:00:00Z/2100-01-01T00:00:00Z",
                            name: gpxdataJSON[i].track_name,
                            label: {
                                text: gpxdataJSON[i].track_name,
                                scale: 1.0,
                                font: "bold 15px Helvetica",
                                fillColor: Cesium.Color.WHITE,
                                outlineWidth: 5,
                                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                            },
                            path: {
                                material: {
                                    solidColor: {
                                        color: {
                                            rgba: [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), 256]
                                        }
                                    }
                                },
                                width: 3,
                                leadTime: 0,
                                trailTime: 15000000,
                                resolution: 60000
                            },
                            position: {
                                interpolationAlgorithm: Cesium.LagrangePolynomialApproximation,
                                interpolationDegree: 5,
                                cartographicDegrees: gpxdataJSON[i].positions
                            },
                            billboard: {
                                image: "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-0411525329.png?w=800&scale.option=noup",
                                scale: 1.0,
                                width: 35,
                                height: 35,
                                verticalOrigin: Cesium.VerticalOrigin.BOTTOM
                            }
                        }
                    ];

                    

                    // Create datasource
                    var czmlDataSource = await new Cesium.CzmlDataSource();
                    await viewer.dataSources.add(czmlDataSource.load(czml));
                    
                    // Set label properties.
                    czmlDataSource.entities.values[0].label.pixelOffset = await new Cesium.Cartesian2(0, -50);
                    czmlDataSource.entities.values[0].label.horizontalOrigin = await Cesium.HorizontalOrigin.LEFT
                    czmlDataSource.entities.values[0].label.outlineColor = await Cesium.Color.BLACK;

                    // Set resource
                    czmlDataSource.entities.values[0].resource = await gpxdataJSON[i].resource;

                    // Add track to filter list
                    await add_track_to_filter_list(czmlDataSource.entities.values[0])

                    // Update resources filter list
                    await update_resources_filter_list(viewer, czmlDataSource.entities.values[0].resource)


                    // Set start time
                    var path_start_time = await czmlDataSource.entities.values[0].position._property._times[0];
                    if (path_start_time < timeline_start) {
                        timeline_start = await path_start_time;
                    }

                    // Position camera in the starting point of the first track and start animation
                    if (is_camera_set === 0) {
                        let lon = gpxdataJSON[i].positions[1]
                        let lat = gpxdataJSON[i].positions[2]
                        let alt = gpxdataJSON[i].positions[3]

                        viewer.camera.flyTo({
                            destination: Cesium.Cartesian3.fromDegrees(lon, lat, alt + 200),
                            orientation: {
                                heading: Cesium.Math.toRadians(0.0),
                                pitch: Cesium.Math.toRadians(-90.0),
                            }
                        });

                        is_camera_set = 1;

                    }
                    
                }

                // Set Animation clock
                viewer.clock.startTime = await timeline_start;
                viewer.clock.multiplier = await 1.0;
                viewer.clock.currentTime = await Cesium.JulianDate.now();
                viewer.timeline.zoomTo(timeline_start, Cesium.JulianDate.now());
                viewer.clock.shouldAnimate = await true;  

                // Update time slider range
                var stopTime = await new Cesium.JulianDate()
                await Cesium.JulianDate.addSeconds(Cesium.JulianDate.now(), 15.0, stopTime)
                viewer.clock.stopTime = await stopTime;
                await load_time_slider_range(viewer);


                           
                // Subscribe to the clock's onTick event
                var streamingIntervalTime = 5000; // 1 second
                var streamingInterval;

                async function stream_data() {

                    var currentTime = await Cesium.JulianDate.now();
                    var gpxdataJSON = await [];

                    // Receive tracks from DB
                    await mapView3dService.receiveGpxTracksData(vm.model.setting.argvalue, 0).then(async function (data) {
                        if (data[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: 'Varsel',
                                message: data[0].errormessage,
                                buttons: [{
                                    label: 'OK',
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                        vm.model.loadingFile = false;
                                    }
                                }]
                            });

                        } else {
                            gpxdataJSON = await JSON.parse(data[0].gpxdata);
                            gpxdataJSON = await gpxdataJSON.gpxdata;
                        }
                    });

                    
                    // Update paths  
                    var newJulianDate = await new Cesium.JulianDate()
                    await Cesium.JulianDate.addSeconds(currentTime, 8, newJulianDate)

                    for (let i = 0; i < gpxdataJSON.length; i++) {

                        // Obtain the dataSource ID if it exists.
                        var track_id = await gpxdataJSON[i].gpxtrack_keyno.toString();
                        var dataSources = await viewer.dataSources._dataSources;
                        
                        var czmlPath = await ""
                        for (let j = 0; j < dataSources.length; j++) {
                            var path_id = await dataSources[j].entities.values[0].id;
                            if (path_id === track_id) {
                                czmlPath = await dataSources[j];
                                break;
                            }
                                
                        }


                        // Stream the last position
                        if (czmlPath !== "") {


                            var updatedCzml = await [{
                                "id": "document",
                                "name": "CZML Model",
                                "version": "1.0"
                            }, {
                                "id": gpxdataJSON[i].gpxtrack_keyno.toString(),
                                "position": {
                                    "interpolationAlgorithm": Cesium.LagrangePolynomialApproximation,
                                    "interpolationDegree": 5,
                                    "cartographicDegrees":
                                        [
                                            Cesium.JulianDate.toIso8601(newJulianDate),
                                            gpxdataJSON[i].positions[1],
                                            gpxdataJSON[i].positions[2],
                                            gpxdataJSON[i].positions[3]
                                        ]

                                }
                            }];

                            czmlPath.process(updatedCzml);

                        // If the path doesnt exist, create a new one.
                        } else {

                            var czml = await [
                                {
                                    id: "document",
                                    name: "CZML Model",
                                    version: "1.0",
                                },
                                {
                                    id: gpxdataJSON[i].gpxtrack_keyno.toString(),
                                    availability: "1970-01-01T00:00:00Z/2100-01-01T00:00:00Z",
                                    name: gpxdataJSON[i].track_name,
                                    label: {
                                        text: gpxdataJSON[i].track_name,
                                        scale: 1.0,
                                        font: "bold 15px Helvetica",
                                        fillColor: Cesium.Color.WHITE,
                                        outlineWidth: 5,
                                        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                                    },
                                    path: {
                                        material: {
                                            solidColor: {
                                                color: {
                                                    rgba: [Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), Math.floor(Math.random() * 256), 256]
                                                }
                                            }
                                        },
                                        width: 3,
                                        leadTime: 0,
                                        trailTime: 1000000000,
                                        resolution: 5
                                    },
                                    position: {
                                        interpolationAlgorithm: Cesium.LagrangePolynomialApproximation,
                                        interpolationDegree: 5,
                                        cartographicDegrees: 
                                            [
                                                Cesium.JulianDate.toIso8601(newJulianDate),
                                                gpxdataJSON[i].positions[1],
                                                gpxdataJSON[i].positions[2],
                                                gpxdataJSON[i].positions[3]
                                            ]
                                    },
                                    billboard: {
                                        image: "https://insoft.sirv.com/TouchTime/html/2023/7/clipboard_2023-07-0411525329.png?w=800&scale.option=noup",
                                        scale: 1.0,
                                        width: 35,
                                        height: 35,
                                        verticalOrigin: Cesium.VerticalOrigin.BOTTOM
                                    }
                                }
                            ];

                            // Turn off animation to add new datasource.
                            viewer.clock.shouldAnimate = await false;  

                            // Create datasource
                            console.log(czml)
                            var czmlDataSource = await new Cesium.CzmlDataSource();
                            await viewer.dataSources.add(czmlDataSource.load(czml));

                            // Set label properties.
                            czmlDataSource.entities.values[0].label.pixelOffset = await new Cesium.Cartesian2(0, -50);
                            czmlDataSource.entities.values[0].label.horizontalOrigin = await Cesium.HorizontalOrigin.LEFT
                            czmlDataSource.entities.values[0].label.outlineColor = await Cesium.Color.BLACK;

                            // Set resource
                            czmlDataSource.entities.values[0].resource = await gpxdataJSON[i].resource;

                            // Add track to filter list
                            await add_track_to_filter_list(czmlDataSource.entities.values[0])

                            // Update resources filter list
                            await update_resources_filter_list(viewer, czmlDataSource.entities.values[0].resource)

                            // Position camera in the starting point of the first track and start animation
                            if (is_camera_set === 0) {
                                let camLon = gpxdataJSON[i].positions[1]
                                let camLat = gpxdataJSON[i].positions[2]
                                let camAlt = gpxdataJSON[i].positions[3]

                                viewer.camera.flyTo({
                                    destination: Cesium.Cartesian3.fromDegrees(camLon, camLat, camAlt + 200),
                                    orientation: {
                                        heading: Cesium.Math.toRadians(0.0),
                                        pitch: Cesium.Math.toRadians(-90.0),
                                    }
                                });

                                is_camera_set = 1;

                            }

                            // Restore clock
                            viewer.clock.multiplier = await 1.0;
                            viewer.clock.startTime = await timeline_start;
                            viewer.clock.currentTime = await Cesium.JulianDate.now();
                            viewer.timeline.zoomTo(timeline_start, Cesium.JulianDate.now());
                            viewer.clock.shouldAnimate = await true;  

                        }

                    }

                    // Update timeline.
                    viewer.timeline.zoomTo(timeline_start, newJulianDate);

                    // Update time_slider
                    var stopTime = await new Cesium.JulianDate()
                    await Cesium.JulianDate.addSeconds(Cesium.JulianDate.now(), 15.0, stopTime)
                    if (viewer.clock.shouldAnimate) {
                        viewer.clock.stopTime = await stopTime;
                        await load_time_slider_range(viewer);
                    }
                    

                };



                streamingInterval = await setInterval(stream_data, streamingIntervalTime);




            }



            // ---------------------- create_live_button ------------------------------ //
            function create_live_button(viewer) {

                let button = document.createElement('button')
                button.id = 'liveButton';
                button.textContent = 'Live';
                button.classList = 'cesium-button';

                button.addEventListener("click", async function () {

                    // Start clock
                    viewer.clock.currentTime = await Cesium.JulianDate.now();
                    viewer.clock.multiplier = await 1.0;
                    viewer.clock.shouldAnimate = await true;

                    // Restore tracks availability.
                    var tracks = viewer.dataSources._dataSources;
                    for (let k = 0; k < tracks.length; k++) {
                        var track = tracks[k].entities.values[0];
                        if (track.path) {
                            track._availability._intervals[0].start = Cesium.JulianDate.fromDate(new Date(1970, 1, 1));
                            track._availability._intervals[0].stop = Cesium.JulianDate.fromDate(new Date(2100, 1, 1));
                         
                        }
                    }


                })

                // Place the button in Cesium's toolbar
                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(button);

            }


            // -------------------------- create_entity_tracker -------------------------------- //
            function create_entity_tracker(viewer){
                viewer.screenSpaceEventHandler.setInputAction(function(click) {
                    // Get the picked object from the click event
                    var pickedObject = viewer.scene.pick(click.position);

                    // Check if the picked object is an entity
                    if (Cesium.defined(pickedObject) && Cesium.defined(pickedObject.id) && pickedObject.id instanceof Cesium.Entity) {
                        var track = pickedObject.id;
                        
                        viewer.selectionIndicator.viewModel.showSelection = true;
                        viewer.selectedEntity = track
                        viewer.trackedEntity = track;
                    
                    }else{
                        viewer.selectionIndicator.viewModel.showSelection = false;
                        viewer.selectedEntity = null
                        viewer.trackedEntity = null;
                    
                    
                    }
                }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
            }


            // --------------------- create_line_thickness_slider ---------------------------- //
            function create_line_thickness_slider(viewer){

                // Create the range input element
                var slider = document.createElement('input');
                slider.id = 'line-thickness-slider';
                slider.type = 'range';
                slider.min = '2';
                slider.max = '7';
                slider.value = '3';
                slider.step = '0.1';

                // Create the paragraph element
                var sliderValue = document.createElement('p');
                sliderValue.id = 'line-thickness-slider-value';
                sliderValue.textContent = 'Line thickness: 3';


                slider.addEventListener("input", function() {
                    var lineWidth = slider.value;
                    sliderValue.textContent = `Line thickness: ${lineWidth}`;
                    
                    var datasources = viewer.dataSources._dataSources 
                    for (let i = 0; i < datasources.length; i++) {
                        var track = datasources[i].entities.values[0]
                        if (track.polyline) {
                            track.polyline.width = lineWidth;
                        }
                        if (track.path) {
                            track.path.width = lineWidth;           
                        }
                    }
                });

                // Add them to cesium viewer container
                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(slider);
                cesiumViewerContainer.appendChild(sliderValue);


            }


            // ------------------------ create_time_slider_html ------------------------------ //
            function create_time_slider_html(viewer){
             
                // Create the main div element
                var divContainer = document.createElement('div');
                divContainer.id = 'time-range';

                // Create the paragraph element
                var paragraph = document.createElement('p');
                paragraph.textContent = 'Time Range: ';

                // Create the span elements
                var spanLeft = document.createElement('span');
                spanLeft.className = 'slider-time-left';

                var spanRight = document.createElement('span');
                spanRight.className = 'slider-time-right';

                var spanHours = document.createElement('span');
                spanHours.className = 'slider-time-hours';

                // Append the span elements to the paragraph element
                paragraph.appendChild(spanLeft);
                paragraph.appendChild(document.createTextNode(' - '));
                paragraph.appendChild(spanRight);
                paragraph.appendChild(document.createTextNode(' ('));
                paragraph.appendChild(spanHours);
                paragraph.appendChild(document.createTextNode(')'));

                // Create the div element for the slider
                var divSlider = document.createElement('div');
                divSlider.id = 'slider-range';

                // Append the paragraph and slider div elements to the main div
                divContainer.appendChild(paragraph);
                divContainer.appendChild(divSlider);

                // Add the main div to the desired parent element or the document body
                let cesiumViewerContainer = document.getElementsByClassName('cesium-viewer')[0];
                cesiumViewerContainer.appendChild(divContainer);
            }

            // ------------------------- load_time_slider_range -------------------------------- //
            var slider
            async function load_time_slider_range(viewer) {

                if (slider) {
                    //await slider.dragslider("destroy");
                }
                

                var cesiumStartTime = await Cesium.JulianDate.toIso8601(viewer.clock.startTime)
                var cesiumStopTime = await Cesium.JulianDate.toIso8601(viewer.clock.stopTime)

                var timeRangeStart = await new Date(cesiumStartTime);
                var timeRangeStop = await new Date(cesiumStopTime);
                var timeRangeStartInit = await cesiumStartTime;
                var timeRangeStopInit = await cesiumStopTime;

                //spanLeft.textContent = timeRangeStart.toUTCString();
                //spanRight.textContent = timeRangeStop.toUTCString();
                //spanHours.textContent = formatDateDifference(timeRangeStart, timeRangeStop);

                $('.slider-time-left').html(timeRangeStart.toUTCString());
                $('.slider-time-right').html(timeRangeStop.toUTCString());
                $('.slider-time-hours').html(formatDateDifference(timeRangeStart, timeRangeStop));
                var min_val = await toTimestamp(timeRangeStartInit);
                var max_val = await toTimestamp(timeRangeStopInit);
                var timeRange = await [min_val, max_val];


                slider = await $("#slider-range").dragslider({
                    range: true,
                    rangeDrag: true,
                    animate: "medium",
                    min: min_val,
                    max: max_val,
                    step: 1,
                    values: timeRange,
                    slide: function (e, ui) {

                        viewer.clock.shouldAnimate = false;  

                        // Get the new time range
                        var timeRangeFrom = new Date(ui.values[0] * 1000); //.format("yyyy-mm-dd hh:ii:ss");                
                        var timeRangeTo = new Date(ui.values[1] * 1000); //.format("yyyy-mm-dd hh:ii:ss");                

                        // Display it
                        $('.slider-time-left').html(timeRangeFrom.toUTCString());
                        $('.slider-time-right').html(timeRangeTo.toUTCString());
                        $('.slider-time-hours').html(formatDateDifference(timeRangeFrom, timeRangeTo));
                        //spanLeft.textContent = timeRangeStart.toUTCString();
                        //spanRight.textContent = timeRangeStop.toUTCString();
                        //spanHours.textContent = formatDateDifference(timeRangeStart, timeRangeStop);

                        

                        // Fix tracks availability
                        var tracks = viewer.dataSources._dataSources;
                        for (let k = 0; k < tracks.length; k++) {
                            var track = tracks[k].entities.values[0];
                            if (track.path) {
                                track._availability._intervals[0].start = Cesium.JulianDate.fromDate(timeRangeFrom)
                                track._availability._intervals[0].stop = Cesium.JulianDate.fromDate(timeRangeTo)
                            }
                        }
                        // The clock follows the upper handle of the slider
                        viewer.clock.currentTime = Cesium.JulianDate.fromDate(timeRangeTo);


                    }

                });


            }


            // ------------------------- create_time_slider -------------------------------- //
            async function create_time_slider(viewer){

                await create_time_slider_html(viewer);
                await load_time_slider_range(viewer);

            }



			// ---------------------------------- main ------------------------------------ //
			async function main(){
				
				// Create viewer
				var viewer = await initialize_cesium_viewer();

                // Decode base64
                vm.model.setting.gpx_content = await atob(vm.model.setting.gpx_content);


                if (vm.model.setting.gpx_content === '') {
                    await initialize_simulation(viewer, [], []);

                } else {
                    // Parse gpx files
                    var { xmlElementArray, xmlElementStringArray, gpxElementsArray } = await parse_gpx_content(vm.model.setting.gpx_content, viewer);

                    // Parse gpx files from local files
                    //var { xmlElementArray, xmlElementStringArray, gpxElementsArray } = await parse_gpx_files(gpx_file_names, viewer);

                    // Initiate simulation
                    await initialize_simulation(viewer, xmlElementArray, gpxElementsArray);

                    // Set HRS resources
                    await set_hrs_resource(viewer);

                    // Create billboards
                    await create_billboards(viewer);

                }

                
                // Create menu to enable/disable waypoints, areas and tracks
                create_waypoints_list_container(viewer);
                create_areas_list_container(viewer);
                create_tracks_list_container(viewer);
                
                // Integration with Google Earth
                create_google_earth_button(viewer);

                // Create heatmaps_list_container
                create_heatmaps_list_container(viewer)

                // Create avalanche layer 
                create_avalanche_layer_button(viewer)

                // Create sun ligh button
                create_lightning_button(viewer)  

                // Create transparency button
                create_terrain_transparancy_button(viewer);

                // Button to toggle 3D tilesets (3D buildings)
                create_3Dtileset_button(viewer);
            
                // Create resources buttons
                create_resources_list_container(viewer)

                // Get my GPS position
                create_get_my_position_button(viewer)



                strart_live_streaming(viewer);



                // Record track
                create_record_track_button(viewer)

                // Create entity tracker 
                create_entity_tracker(viewer)

                // Create line thickness slider
                create_line_thickness_slider(viewer);

                // Time range slider
                create_time_slider(viewer);
                
                // Live button
                create_live_button(viewer);



            }
			
			


			// Check that cesium is loaded before running
			load_initial_parameters().then(function() {
				if (typeof Cesium !== 'undefined') {
				  main()
				}
			});

			

			
			
		}]
	});
})();